import { Component, OnInit, Injector, Input, ViewChild, ViewContainerRef, Output, EventEmitter, ElementRef, ChangeDetectorRef, NgZone, OnDestroy } from '@angular/core';
import { MainComponent } from '../main-component/main.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalSize } from '../../services/smart-modal.service';
import { FormComponent } from '../form/form.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PopupFormComponent } from '../popupform/popupform.component';
import { Subscription } from 'rxjs';
import { AsideBarService } from '../../services/asideBar.service';
import { HttpParams } from '@angular/common/http';
import { QrCodeGeneratorComponent } from '../qr-code-reader/qr-code-generator/qr-code-generator.component';
import { DialogModalSize } from '../dialog/dialog-ref';
import { AIService } from '../aiml/services/ai.service';
import { CommonService } from '../../services/common.service';
import { TemplateInterceptorComponent } from '../template-interceptor/template-interceptor.component';
declare var jQuery: any;
@Component({
  selector: 'app-ui-engine',
  templateUrl: './ui-engine.component.html',
  styleUrls: ['./ui-engine.component.scss'],
  standalone: false
})
export class UiEngineComponent extends MainComponent implements OnInit,OnDestroy {
  @ViewChild('formComponenet') formComponenet: FormComponent;
  @ViewChild('sideBarMenuRef') sideBarMenuRef: any;
  @Input() resourcename: any = '';
  @Input() decoratorname: any = '';
  @Input() current_action: String = '';
  @Input() parent_id: any;
  @Input() showGridOnly: boolean;
  @Input() bannerJson: any;
  @Input() showPopUp: boolean = false;
  @Input() filter: any;
  @Input() tabLayoutName: any;
  // Set by callers that mount this component OUTSIDE routing (e.g.
  // ResourcePopupComponent embeds it inline in a dialog) - listResource()'s
  // post-submit router.navigate([...]) targets the app's real router, which
  // has nothing to do with the dialog and just navigates the page behind it.
  // When true, that navigation (and the equivalent tab-layout branch in
  // afterSubmitActions()) is skipped and listNavigationSkipped fires instead
  // so the caller can react (e.g. close its dialog) without the app
  // navigating anywhere.
  @Input() suppressListNavigation: boolean = false;
  @Output() saveFinished: EventEmitter<any> = new EventEmitter(); //fires when form submits
  // Fires in place of the post-submit list navigation when suppressListNavigation is true.
  @Output() listNavigationSkipped: EventEmitter<any> = new EventEmitter();
  public _currentData: any = {};
  public _layout: string = 'simple';
  public _layout_id: string = null;
  public arg_key: any;
  public _layout_data: any = {};
  public hasSubscription = new Subscription();
  private activeTabTimeout: any = null;
  private routeParamsSubscription: Subscription = new Subscription();
  @ViewChild('customComponent', { read: ViewContainerRef }) customComponent: ViewContainerRef;
  @ViewChild('parentComponent', { read: ViewContainerRef, static: false }) parentComponent: ViewContainerRef;
  @ViewChild('tabWidth_') tabWidth: ElementRef;
  sidebarOpen: any = false;filteredLayoutKeys:any
  ehr_view_default: any;
  archiveMessage = "Data is ready to download.";
  currentResourceConfig: any;
  gridPopupValidation: boolean;
  _copy_layout_data: any
  bannerData: any;
  projectionEnabled:boolean = false;
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService,
    public asideBarService?: AsideBarService,
    public commonServiceUi?: CommonService,
    public ngZone?: NgZone
  ) {
    super(injector, route);
    if (!this.ngZone) {
        this.ngZone = this.injector.get(NgZone); 
    }
  }
  ngOnInit() {
    this.projectionKeysConfig()
    this.uiInit();
  }
  uiInit(config?) {
    if (!this.parent_id) {
      this.parent_id = 0;
    }
    if (this._currentData.origArhiveConfig == undefined) {
      let archiveConfig: any = false;
      if (this._currentData.archiveConfig != undefined && config && config["archiveConfig"] != undefined && config["archiveConfig"] != undefined) {
        archiveConfig = this._currentData.archiveConfig;
      }
      this.initCurrentData();
      if (config && config["archiveConfig"] != undefined) {
        if (archiveConfig) {
          this._currentData["archiveConfig"] = archiveConfig;
        } else {
          this._currentData["archiveConfig"] = {};
        }
        this._currentData["archiveConfig"]["selected"] = config["archiveConfig"];
        this._currentData["archiveConfig"]["applied"] = true;
        this._currentData.dataGridConfig = {};
        this._currentData.gridData.page_no = 0;
        this.updatePageInUrl(this._currentData.gridData.page_no, true);
      } else {
        //if its archive old filter and page number is not needed bevause we may not support the applied filters on archive data
        this._currentData.loadSavedFilter = true;
        if (this.route.snapshot.queryParams["p__no"] != undefined) {
          this._currentData.gridData.page_no = parseInt(this.route.snapshot.queryParams["p__no"])
        }
      }
      if (this.resourcename) {
        this._currentData.resource = this.resourcename;
        this._currentData.json = this._currentData.resource;
      } else if (this.route.snapshot.data.resource != undefined) {
        this._currentData.resource = this.route.snapshot.data.resource;
        this._currentData.json = this._currentData.resource;
      } else if (this.route.snapshot.paramMap.get('resource') != null) {
        this._currentData.resource = this.route.snapshot.paramMap.get('resource');
        this._currentData.json = this.route.snapshot.paramMap.get('resource');
      }
      if (this.route.snapshot.data.view != undefined && this.route.snapshot.data.view) {
        this._currentData.view = this.route.snapshot.data.view;
        this._currentData.json = this._currentData.view;
      }
      //Archive in case of schema is change, then all json will be overridden with archive config resource
      if (config && config.archiveConfig != undefined && config["archiveConfig"].resource != undefined) {
        this._currentData.resource = config["archiveConfig"].resource;
        this._currentData.json = this._currentData.resource;
      }
    } else {
      //archive is loading
      var origArhiveConfig = JSON.parse(JSON.stringify(this._currentData.origArhiveConfig));
      this.initCurrentData();
      this._currentData.origArhiveConfig = origArhiveConfig;
      this._currentData.json = this._currentData.origArhiveConfig.resource;
    }
    this._currentData.bookmarks = undefined;
    this.baseService.getResourceDef(this._currentData.json, (resouceDef) => {
      if (resouceDef) {
        // this.preferenceService.getUserPreferenceConfig(this._currentData.save_key, (preferenceData) => {
        //   this._currentData.preferenceData = preferenceData;
        this._currentData.currentResource = resouceDef.resource;
        // if(res)
        if (resouceDef.layout_type != undefined && resouceDef.layout_type) {
          this._layout = resouceDef.layout_type
        } else {
          this._layout = 'simple';
        }
        // this._currentData.dataGridConfig.view_current_data = resouceDef && resouceDef.config != undefined && resouceDef.config.view_current_data != undefined ? resouceDef.config.view_current_data : false;
        if (this._currentData.origArhiveConfig != undefined) {
          if (resouceDef.config == undefined) {
            resouceDef.config = {};
          }
          this._currentData.gridData.page_no = 0;//resetting page
          resouceDef.config.archive = this._currentData.origArhiveConfig;
          resouceDef.config.archive.isON = true;

        }
        if (this._layout == 'simple') {
          //Archive in case of schema is change, then all json will be overridden with archive config resource
          if (config && config.archiveConfig != undefined && config["archiveConfig"].resource != undefined && this._currentData["archiveConfig"] != undefined) {
            if (resouceDef.config == undefined) {
              resouceDef.config = {};
            }
            resouceDef.config.archiveConfig = this._currentData["archiveConfig"]
          }
          this.loadInitalConfig(this._currentData.json, () => {
            if (this._currentData.uiConfigData != undefined && this._currentData.uiConfigData) {
              var afterConfig = this.preferenceService.applyJsonConfig({ resouceDef: resouceDef }, this._currentData.uiConfigData);
              if (afterConfig.resouceDef != undefined) {
                resouceDef = afterConfig.resouceDef;
              }
            }
            this.checkIfArchiveAvailable(resouceDef);
            this._layout_data = resouceDef;
            this.initLayoutData();
          });

        } else {
          /*Calling Same code Just 
            layoutRenderer() Have same same code */

          this.layoutRenderer(resouceDef);
        }
        //});
      }
    });
    this.getParamValueQueryString('key', (response) => {
      if (response) {
        this.arg_key = response;
      }
    });
  }

  getString(data) {
    return JSON.stringify(data);
  }
  checkIfArchiveAvailable(resourceDef) {
    this.utilService.checkIfArchiveAvailable(resourceDef, this);
  }

  removeFilterForArchive(archiveConfig, resourceDef) {
    this.utilService.removeFilterForArchive(archiveConfig, resourceDef, this);
  }

  loadInitalConfig(resourceName, callback) {
    this.preferenceService.loadInitalConfig(this, resourceName, callback);
  }

  initTabDrag() {
    if (this._currentData.json != undefined && this._currentData.json) {
      try {
        jQuery('#tab_' + this._currentData.json).dragableColumns({
          drag: true,
          dragClass: 'drag',
          overClass: 'over',
          movedContainerSelector: '.dnd-moved',
          onDragEnd: (fromIndex, toIndex) => {
            this.tabDragEnd(fromIndex, toIndex);
          }
        });
      } catch (e) {
        console.error(e);
      }

    }
  }

  tabDragEnd(fromIndex, toIndex) {
    try {
      if (this._layout_id) {
        let layouKey = "__tab_order";
        this._currentData.preferenceData[layouKey] = (this._currentData.preferenceData[layouKey] != undefined) ? this._currentData.preferenceData[layouKey] : {};
        var keys = Object.keys(this._layout_data);
        this._currentData.preferenceOrder = [];
        this.assignIndexOftabs(keys, this._currentData.preferenceData[layouKey]);
        if (keys[fromIndex] != undefined && keys[toIndex] != undefined) {
          let fromKey = this._currentData.preferenceOrder[fromIndex];
          let toKey = this._currentData.preferenceOrder[toIndex];
          this._currentData.preferenceData[layouKey][fromKey] = toIndex;
          this._currentData.preferenceData[layouKey][toKey] = fromIndex;
        }
        console.log(fromIndex, toIndex);
        console.log(keys);
        this._currentData.preferenceData = JSON.parse(JSON.stringify(this._currentData.preferenceData));
        this.savePreference();//currently broken I have to fix (key is broken)
      }
    } catch (e) {
      console.error(e);
    }
  }

  assignIndexOftabs(keys, array) {
    //too complicated without jquery.
    jQuery("#tab_" + this._currentData.json + " li").each((index, ele) => {
      if (jQuery("#tab_" + this._currentData.json).find('a').length && jQuery(ele).find("a").attr("id") != undefined) {
        var singleKey = jQuery(ele).find("a").attr("id");
        this._currentData.preferenceOrder[index] = singleKey;
        array[singleKey] = index;
      } else if (jQuery(ele).attr("id") != undefined) {
        var singleKey = jQuery(ele).attr("id");
        this._currentData.preferenceOrder[index] = singleKey;
        array[singleKey] = index;
      }
    });
  }
  savePreference() {
    var saveKey: any = this._currentData.json + '_list_config';

    if (this._currentData.resouceDef != undefined && this._currentData.resouceDef.resource) {
      saveKey = this._currentData.resouceDef.resource + '_list_config';
    }

    this.preferenceService.saveTableConfigData(saveKey, this._currentData.preferenceData, () => {

    });
  }
  //not used
  resetPreference() {
    // this.preferenceService.delteConfigData(this._currentData.save_key, () => {
    //   this._currentData.preferenceData = {};
    //   this._currentData.preferenceData = JSON.parse(JSON.stringify(this._currentData.preferenceData));
    // });
  }
  checkData(obj) {
    if (Object.keys(obj).length === 0) {
      return false;
    }
    return true;
  }
  /*  By ravi 
  * no effect on Previous Code this is to makeLayoutData*/
  layoutRenderer(resouceDef) {
    // written for emr specific - todo need to remove this
    if (this.route.snapshot.params.hasOwnProperty('action') && this.route.snapshot.params.action == "view") {
      resouceDef.layout.forEach(tab => {
        if (tab.action != "TAB")
          tab['action'] = 'LIST';
        this._currentData.addAllowed == false;
      });
    }
    this._layout_data = {};
    // this.activeTab(resouceDef.layout[0].id);
    this._currentData.tabType = resouceDef.tab_type;
    if (resouceDef.config != undefined && resouceDef.config.list_back_navigation != undefined)
      this._currentData.list_back_navigation = resouceDef.config.list_back_navigation;
    // if (this._currentData.tabType == 'vertical') {
    //   this.communicationService.emitSidebar({ sidebar: false });
    //   this.communicationService.emitChange({ hideMenuIcon: true });
    // }
    this._currentData.tabName = resouceDef.default_layout_id;
    if (resouceDef.default_layout_id != undefined && resouceDef.default_layout_id) {
      this._layout_id = resouceDef.default_layout_id;
    }
    if (resouceDef.banner && resouceDef.banner != undefined) {
      this._currentData.bannerJson = resouceDef.banner;
      this._currentData.showBanner = true;
    }
    if (resouceDef.conditionVisible != undefined) {
      this._currentData.conditionVisibleTab = resouceDef.conditionVisible;
    }
    if (resouceDef.layout != undefined && resouceDef.layout.length) {
      resouceDef.layout = this.rolePermissionService.getAllowedTabs(resouceDef.layout);
      if (resouceDef.default_layout_id == undefined && resouceDef.layout && resouceDef.layout.length > 0)
        this._layout_id = resouceDef.layout[0].id;
      let allPromiseObj: any = [];
      var defaultLayoutFound = false;
      for (const layout of resouceDef.layout) {
        if (resouceDef.default_layout_id != undefined && resouceDef.default_layout_id == layout.id) {
          defaultLayoutFound = true;
        }
        this._layout_data[layout.id] = {};
        this._layout_data[layout.id]['data'] = layout;
        allPromiseObj.push(this.asyncProcess(layout));
      }
      if (resouceDef.default_layout_id != undefined && !defaultLayoutFound && resouceDef.layout.length > 0) {
        this._layout_id = resouceDef.layout[0].id;
      }
      //Checking if all resource json are loaded.
      Promise.all(allPromiseObj).then(() => {
        console.log("Layout Data ", this._layout_data);
        //If no permission redirect to 404
        if (Object.keys(this._layout_data).length > 0)
          this.initLayoutData();
        else
          this.router.navigate(['404'], { skipLocationChange: true });
      });
      // this._currentData.tabConfig = resouceDef.config;
    } else {
      alert("ERROR PLEASE FIX");
    }
  }

  asyncProcess(layout) {
    return new Promise((resolve, reject) => {
      if (layout.resource) {
        this.baseService.getResourceDef(layout.resource, (currentResouceDef) => {
          this._layout_data[layout.id]['resource_def'] = currentResouceDef;
          resolve(true);
        });
      } else {
        this._layout_data[layout.id]['resource_def'] = layout.component;
        if (layout.banner) {
          this._layout_data[layout.id]['resource_def'].banner = layout.banner;
          this._currentData.showBanner = true;
        }
        resolve(true);
      }
    });
  }

  initLayoutData(action?) {
    if (this._currentData.tabType == 'vertical') {
      this.communicationService.emitSidebar({ sidebar: false });
      this.communicationService.emitChange({ hideMenuIcon: true });
    }
    var resouceDef = null;
    if (this._layout == 'simple') {
      resouceDef = this._layout_data;
      if (!this.showGridOnly) {
        if (this.route.snapshot.data.action != undefined) {
          if (resouceDef.config != undefined && (resouceDef.config.first_action == undefined || resouceDef.config.first_action == '')) {
            this._currentData.currentAction = this.route.snapshot.data.action;
          } else {
            if (this.route.snapshot.data.action != 'LIST') {
              //FORM GRID WILL WORK ONLY IN CASE OF LIST ACTION.
              this._currentData.currentAction = this.route.snapshot.data.action;
              //  this._currentData.currentAction = resouceDef.first_action;
            } else if (resouceDef.config != undefined && resouceDef.config.first_action != undefined) {
              this._currentData.currentAction = resouceDef.config.first_action;
            } else {
              this._currentData.currentAction = 'LIST';
            }
          }
        } else if (this.current_action != undefined && this.current_action) {
          this._currentData.currentAction = this.current_action;
        }
        else if (this._currentData && this._currentData.currentAction == undefined) {
          this._currentData.currentAction = 'LIST';
        }
      }
      else if (resouceDef.config != undefined && resouceDef.config.popUp_action != undefined) {
        this._currentData.currentAction = resouceDef.config.popUp_action;
        if (this._currentData['popUiengineConfig'] != undefined)
          this._currentData['popUiengineConfig']['buttonConf'] = false;
      }
      else { // In popup for showing only grid
        this._currentData.currentAction = 'LIST';
      }
      this.ruleEngineService.getPermission(resouceDef).then((response) => {
        this._currentData.ruleEngine = response;
        if (this._currentData.dataGridConfig == undefined) {
          this._currentData.dataGridConfig = {};
        }
        this._currentData.dataGridConfig.ruleEngine = this._currentData.ruleEngine;
        console.log("this._currentData.ruleEngine", this._currentData.ruleEngine);
      });
      this.getComponentType(resouceDef);
    } else {
      var tab_key = 'tab_' + this.parent_id;
      if (this._currentData.conditionVisibleTab && this._currentData.conditionVisibleTab != undefined) {
        let promiseObj: any = [];
        promiseObj.push(this.checkCondition(this._currentData.conditionVisibleTab, this._currentData.bannerJson));
        Promise.all(promiseObj).then(() => {
          if (this._layout_id && this._layout_data[this._layout_id] != undefined && this._layout_data[this._layout_id]['resource_def'] != undefined) {
            resouceDef = JSON.parse(JSON.stringify(this._layout_data[this._layout_id]['resource_def']));
            // console.log("resource def is :: ", resouceDef);
            this._currentData.tabLayout = this._layout_data[this._layout_id]['data'];
            var data = this._layout_data[this._layout_id]['data'];
            resouceDef.child_tab = (data.child_tab != undefined && data.child_tab) ? data.resource : false;//setting resource name here which will be used as input to recursivly call ui-engine
            resouceDef.parent_selector = (data.selector != undefined && data.selector) ? data.selector : false;
          }
          if (resouceDef) {
            this.checkIfArchiveAvailable(resouceDef);
            this.loadInitalConfig(resouceDef.resource, () => {
              if (this._currentData.uiConfigData != undefined && this._currentData.uiConfigData) {
                var afterConfig = this.preferenceService.applyJsonConfig({ layout: this._layout_data, resouceDef: resouceDef }, this._currentData.uiConfigData);
                let ifDefaultChanged = false;
                if (afterConfig.layout != undefined) {
                  //this._layout_data = afterConfig.layout;
                  this._layout_data = { ...afterConfig.layout };
                  ifDefaultChanged = this.resetDefaultTabIfNotFound(afterConfig);
                }
                if (afterConfig.resouceDef != undefined) {
                  if (ifDefaultChanged) {
                    this.loadInitalConfig(afterConfig.resouceDef.resource, () => {
                      var afterConfigSimple = this.preferenceService.applyJsonConfig({ resouceDef: afterConfig.resouceDef }, this._currentData.uiConfigData);
                      if (afterConfigSimple.resouceDef != undefined) {
                        resouceDef = afterConfigSimple.resouceDef;
                      } else {
                        resouceDef = afterConfig.resouceDef;
                      }
                      this.getAction(resouceDef, action);
                    });
                  } else {
                    resouceDef = afterConfig.resouceDef;
                    this.getAction(resouceDef, action);
                  }
                } else {
                  this.getAction(resouceDef, action);
                }
              } else {
                this.getAction(resouceDef, action);
              }


            });
          }
        });
      } else {
        if (!this.showPopUp)
          this._layout_id = this.route.queryParams['value'][tab_key] == undefined || null ? this._layout_id : this.route.queryParams['value'][tab_key]; //setting resource for tab current tab active
        if (this._layout_id && this._layout_data[this._layout_id] != undefined && this._layout_data[this._layout_id]['resource_def'] != undefined) {
          if (this._currentData.tabType == 'vertical' && this._layout_data[this._layout_id]['data'] != undefined && this._layout_data[this._layout_id]['data'].name_change) {
            this._currentData.tabLayoutName = this._layout_data[this._layout_id]['data']?.layoutName;
          }
          resouceDef = JSON.parse(JSON.stringify(this._layout_data[this._layout_id]['resource_def']));
          console.log("resource def is :: ", resouceDef);
          var data = this._layout_data[this._layout_id]['data'];
          resouceDef.child_tab = (data.child_tab != undefined && data.child_tab) ? data.resource : false;//setting resource name here which will be used as input to recursivly call ui-engine
          resouceDef.parent_selector = (data.selector != undefined && data.selector) ? data.selector : false;
        }
        if (resouceDef) {
          this.checkIfArchiveAvailable(resouceDef);
          this.loadInitalConfig(resouceDef.resource, () => {
            if (this._currentData.uiConfigData != undefined && this._currentData.uiConfigData) {
              var afterConfig = this.preferenceService.applyJsonConfig({ layout: this._layout_data, resouceDef: resouceDef }, this._currentData.uiConfigData);

              //setting projection keys as per the field visibility
              if (resouceDef != undefined && resouceDef.list != undefined && resouceDef.list.fields != undefined && resouceDef.list.fields.length != undefined && resouceDef.list.fields.length > 0 && resouceDef.config != undefined && resouceDef.config.projection_keys != undefined && resouceDef.config.dynamicProjection != undefined && resouceDef.config.dynamicProjection) {
                this.setProjectionKeys(resouceDef.list.fields, resouceDef.list.projectionKeys);
              }


              let ifDefaultChanged = false;
              if (afterConfig.layout != undefined) {
                //this._layout_data = afterConfig.layout;
                this._layout_data = { ...afterConfig.layout };
                ifDefaultChanged = this.resetDefaultTabIfNotFound(afterConfig)
              }
              if (afterConfig.resouceDef != undefined) {
                if (ifDefaultChanged) {
                  this.loadInitalConfig(afterConfig.resouceDef.resource, () => {
                    var afterConfigSimple = this.preferenceService.applyJsonConfig({ resouceDef: afterConfig.resouceDef }, this._currentData.uiConfigData);
                    if (afterConfigSimple.resouceDef != undefined) {
                      resouceDef = afterConfigSimple.resouceDef;
                    } else {
                      resouceDef = afterConfig.resouceDef;
                    }
                    this.getAction(resouceDef);
                  });
                } else {
                  resouceDef = afterConfig.resouceDef;
                  this.getAction(resouceDef);
                }
              } else {
                this.getAction(resouceDef);
              }
            } else {
              this.getAction(resouceDef);
            }

          });
        }
      }

      // setTimeout(() => {
      //   this.initTabDrag();
      // }, 100);//add drag functionality after 100ms
    }
    this._copy_layout_data = JSON.parse(JSON.stringify(this._layout_data));
  }


  setProjectionKeys(fields, addProj?: []) {
    try {
      if (this._currentData.archiveConfig != undefined && this._currentData.archiveConfig.selected != undefined && this._currentData.archiveConfig.selected.select_all != undefined && this._currentData.archiveConfig.selected.select_all) {
        this._currentData.gridData.projectionKeys = [];
      } else {
        this._currentData.gridData.projectionKeys = this.baseService.getProjectionKeys(fields, addProj);
      }
    } catch (error) {

    }

  }

  resetDefaultTabIfNotFound(afterConfig) {
    if (Object.keys(this._layout_data).indexOf(this._layout_id) == -1) {
      //default layout not found in allowed tabs;
      this._layout_id = Object.keys(this._layout_data)[0];
      if (this._layout_id && this._layout_data[this._layout_id] != undefined && this._layout_data[this._layout_id]['resource_def'] != undefined) {
        afterConfig.resouceDef = this._layout_data[this._layout_id]['resource_def'];
        return true;
      }
    }
    return false;
  }
  setDynamicTemplate(parentId, resource, template) {
    if (!template)
      template = 'app-ui-engine';
    setTimeout(() => {
      if (this.parentComponent)
        this.parentComponent.clear();
      this.baseService.createComponent(template, this.parentComponent, (respose) => {
        if (respose) {
          console.log("callback is", respose);
          respose.instance.parent_id = parentId;
          respose.instance.resourcename = resource;
          respose.instance.bannerData = this.bannerData;
          respose.instance.tabLayoutName = this._currentData.tabLayoutName || this.tabLayoutName;
        }
      })
    })
  }
  getAction(resouceDef, action?) {
    this.ruleEngineService.getPermission(resouceDef).then((response) => {
      this._currentData.ruleEngine = response;
      if (this._currentData.dataGridConfig == undefined) {
        this._currentData.dataGridConfig = {};
      }
      this._currentData.dataGridConfig.ruleEngine = this._currentData.ruleEngine;
      console.log("this._currentData.ruleEngine", this._currentData.ruleEngine);
    });
    try {
      if (action != undefined) {
        this._currentData.currentAction = action;
      } else {
        if (this._layout_data[this._layout_id]['data'].action != undefined) {
          this._currentData.currentAction = this._layout_data[this._layout_id]['data'].action;
        } else {
          this._currentData.currentAction = 'LIST';
        }
      }
    } catch (e) {
      this._currentData.currentAction = 'LIST';
    }
    this.getComponentType(resouceDef);
    console.log("this._currentData.currentAction", this._currentData.currentAction);
  }

  getComponentType(resouceDef) {
    if (this._layout == 'simple' && !this.showGridOnly) {
      if (this._currentData.currentAction == 'LIST' && resouceDef.config && resouceDef.config.list_back_navigation)
        this.baseService.backNavigation = true;
      else if (this._currentData.currentAction != 'LIST') {
        if (resouceDef.config != undefined && (resouceDef.config.back_navigation == false || resouceDef.config.show_title == false)) {
          this.baseService.backNavigation = false;
        } else {
          this.baseService.backNavigation = true;
        }
      } else {
        this.baseService.backNavigation = false;
      }
    } else {
      this.baseService.backNavigation = false;
    }
    console.log("this._currentData.currentAction ", this._currentData.currentAction, this.baseService.backNavigation);
    if (this._currentData.currentAction == 'CONFIRM') {
      this.confirmBoxResource({}, this._layout_data[this._layout_id]['data']);
    } else {
      if (resouceDef) {
        // For setting title
        if (!this.showPopUp) {
          if (this.route.snapshot.data.page_name != undefined && this.route.snapshot.data.page_name) {
            this.baseService.setTitleFromResouceDef(this.route.snapshot.data, this.route.snapshot.data.action); // Set Page name,title from route
          } else {
            this.baseService.setTitleFromResouceDef(resouceDef, this._currentData.currentAction); // Set Page name,title
          }
        }

        if (resouceDef.parameters != undefined && resouceDef.parameters) {
          this._currentData.parameters = resouceDef.parameters;
        }
        if (this.route.snapshot.queryParamMap.get('data') != undefined && this.route.snapshot.queryParamMap.get('data')) {
          try {
            this._currentData.routeData = JSON.parse(this.route.snapshot.queryParamMap.get('data'));
          } catch (error) { }
        }
        //assign action and other data here
        if (resouceDef.selector == undefined) {
          if (this.customComponent)
            this.customComponent.clear();//check if dyanamic component is not loading here
        } else {
          this._currentData.currentAction = 'CUSTOM';
          console.log(resouceDef, 'resouceDef');
          this._currentData.resouceDef = resouceDef;
          this.createComponent(resouceDef.selector, resouceDef.input) //add selector name here for tabs overide 
        }
        this.getDataForCurdOperation(resouceDef);
      }
    }
  }
  //override for checking condition in billing 
  checkCondition(cond, banner) {

  }
  //override button label and title
  hasLabel() {
    if (this._currentData.hasOwnProperty("resouceDef") == true) {

    }
  }

  showBookmarks() {
    //to be overridden
  }
  createComponent(kxselector: any, input?) {
    setTimeout(() => {
      this.customComponent.clear();
      this.baseService.createComponent(kxselector, this.customComponent, (respose) => {
        if (respose) { // code added by  sanjeev if your custom component is not working revert it but due to this code custom component is not working in EMR
          console.log("callback is", respose);
          respose.instance.input = input;
          respose.instance.resource = this._currentData.resouceDef;
          respose.instance.bannerJson = this._currentData.bannerJson;
          respose.instance.bannerData = this.bannerData;
          respose.instance.tabLayoutName = this._currentData.tabLayoutName || this.tabLayoutName;
        }
      })
    })
  }


  initCurrentData() {
    this._currentData = {
      'addAllowed': true,
      'config': {
        'activeField': 'table',
        'tile': false,
        'table': true,
      },
      'dataList': [],
      'filterList': [],
      'gridData': {},
      "showBanner": false,
      "customClick": false,
      "render_template": true,
      "tabClick": false,
      'showView': false,
      "showAddButton": true,
      "bulkAction": false,
      "currentListFields": [],
      "cardHeader": {},
      "defaultFormData": {},
      "currentFormFields": {},
      "foreignKeyData": {},
      "decorator": false,
      "summary": {},
      "filterDecorator": false,
      "default_filter": false,
      "ruleEngine": {}
    }
    if (this.tabLayoutName) {
      this._currentData.tabLayoutName = this.tabLayoutName;
    }
    this._currentData.currentFormFields.loaded = false;
  }

  getDataForCurdOperation(resouceDef) {

    this._currentData.resouceDef = resouceDef;
    // localStorage.setItem("CurrentResource", resouceDef.resource);
    this.storageService.setCurrentResource(resouceDef.resource)
    if (this._layout != 'simple') {
      this._currentData.resource = resouceDef.resource;
    }
    if (resouceDef.addButton != undefined && resouceDef.addButton) {
      this._currentData.addButton = resouceDef.addButton;
      this._currentData.addButton.qrCodeScanner = (resouceDef.addButton && resouceDef.addButton.qrCodeScanner ? resouceDef.addButton.qrCodeScanner : true);
    }
    if (resouceDef?.list?.mobile_card_resource) {
      if (!this._currentData.dataGridConfig) {
        this._currentData.dataGridConfig = {};
      }
      this._currentData.dataGridConfig.mobile_card = true;
      this._currentData.dataGridConfig.mobile_card_resource = resouceDef.list.mobile_card_resource;
    }
    this._currentData.summary = {};
    if (resouceDef && resouceDef.summary != undefined && resouceDef.summary) {
      this._currentData.summary = resouceDef.summary;
      this._currentData.summary.hideSummaryButton = false;
    }
    if (resouceDef.query_id != undefined && resouceDef.query_id) {
      this._currentData.query_id = resouceDef.query_id;
    }
    if (this.route.snapshot.queryParams.hasOwnProperty('banner')) {
      this._currentData.bannerJson = JSON.parse(this.route.snapshot.queryParams.banner);
      if (resouceDef.args == undefined)
        this._currentData.showBanner = true;
    } else if (this._currentData.bannerJson != undefined && this._currentData.bannerJson) {
      if (resouceDef.args == undefined)
        this._currentData.showBanner = true;
    } else if (resouceDef.banner != undefined && resouceDef.banner) {
      this._currentData.bannerJson = resouceDef.banner;
      if (resouceDef.args == undefined)
        this._currentData.showBanner = true;
    } else if (this.bannerJson && this.bannerJson != undefined) {
      this._currentData.bannerJson = this.bannerJson;
    }
    /******************* ACCOUNT AWARE ***************/
    if (this._currentData.bannerJson != undefined && resouceDef.config != undefined && resouceDef.config.account_aware != undefined && this.appService.isFacilityAware()) {
      this._currentData.bannerJson.accountAware = resouceDef.config.account_aware;
    }
    /******************* ACCOUNT AWARE ***************/

    this.getFilter();

    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this.decoratorname != "") {
      this._currentData.decorator = this.baseService.initDecorator(this.decoratorname, this.route, this.injector);
    } else if (resouceDef.config != undefined && resouceDef.config.decorator != undefined) {
      //if decorator  not initialzed or its not same as previous decorator then initialze it
      if (!this._currentData.decorator || (this._currentData.decorator && this._currentData.decorator.className != undefined && this._currentData.decorator.className != resouceDef.config.decorator)) {
        this._currentData.decorator = this.baseService.initDecorator(resouceDef.config.decorator, this.route, this.injector);
      }
    }

    if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.decorator.processResourceDef != undefined) {
      resouceDef = this._currentData.decorator.processResourceDef(resouceDef);
      this._currentData.resouceDef = resouceDef;
    }
    /******** DEOCRATOR IMPLEMENTATION *******/

    if (resouceDef.form != undefined && resouceDef.form) {

      /*********** loading default form data from path if available */
      if (this._currentData.currentAction === 'ADD' && this.route.snapshot.data.form_data != undefined && this.route.snapshot.data.form_data[this._currentData.currentResource] != undefined) {
        this._currentData.defaultFormData = this.route.snapshot.data.form_data[this._currentData.currentResource];
      } else {
        if (window.history.state != undefined && window.history.state.form_data != undefined) {
          this._currentData.defaultFormData = window.history.state.form_data;
        } else {
          this._currentData.defaultFormData = {};
        }

      }

      /*********** loading default form data from path if available */

      this.baseService.getReferredField(resouceDef.form, (response) => {
        console.log("Response is ", response);
        this.initConfigForForm(resouceDef);
        if (resouceDef.form.id)
          this._currentData.currentFormFields.id = resouceDef.form.id;
        if (resouceDef.form.datasource)
          this._currentData.currentFormFields.datasource = resouceDef.form.datasource;
        if (resouceDef.form.resetForm)
          this._currentData.currentFormFields.resetForm = resouceDef.form.resetForm;
        if (resouceDef.form.hasOwnProperty('submitButton')) {
          this._currentData.currentFormFields.submitButton = resouceDef.form.submitButton;
        } else {
          this._currentData.currentFormFields.submitButton = true;
        }
        if (resouceDef.form.hasOwnProperty('APIresource')) {
          this._currentData.currentFormFields.APIresource = resouceDef.form.APIresource;
        }
        if (resouceDef.form.hasOwnProperty('append_object')) {
          this._currentData.currentFormFields.append_object = resouceDef.form.append_object;
        }
        this._currentData.currentFormFields.bannerJson = this._currentData.bannerJson;
        this._currentData.currentFormFields.blocks = response;
        this._currentData.currentFormFields.loaded = true;

        this._currentData.customButton = resouceDef.custom_button || {
          "Add": [
            {
              "label": "button.submit",
              "icon": "fa fa-check"
            }
          ],
          "Modify": [
            {
              "label": "button.update",
              "icon": "fa fa-check"
            }
          ]
        };
        if (resouceDef.form.bookmark && this._currentData.bookmarks == undefined) {
          this._currentData.bookmarks = resouceDef.form.bookmark
          this.showBookmarks();
        }
        this.getDataForCrudOperationFn(resouceDef);
      });
    }
    else {
      this.getDataForCrudOperationFn(resouceDef);
    }
  }


  getDataForCrudOperationFn(resouceDef) {
    this._currentData.dataGridConfig = (this._currentData.dataGridConfig == undefined) ? {} : this._currentData.dataGridConfig;
    if (resouceDef.list != undefined && resouceDef.list) {
      if (resouceDef.list.filter != null) {
        if (resouceDef.list.filter.default_filter != undefined)
          this._currentData.default_filter = resouceDef.list.filter.default_filter
        else
          this._currentData.default_filter = false
        //commented as we have resource already
        this._currentData.currentFilterListFormFields = {};
        this._currentData.currentFilterListFormFields.blocks = resouceDef;
        if (resouceDef.list.filter.quick_filters != undefined && typeof resouceDef.list.filter.quick_filters == 'object' && resouceDef.list.filter.quick_filters.length > 0) {
          this._currentData.currentFilterListFormFields.quick_filters = [];
          resouceDef.list.filter.quick_filters.forEach(elem => {
            if (elem.expression) {
              let valid;
              valid = eval(elem.expression)
              if (valid != undefined && valid != null && valid) {
                this._currentData.currentFilterListFormFields.quick_filters.push(elem)
              }
            } else
              this._currentData.currentFilterListFormFields.quick_filters.push(elem)
          });
          this._currentData.quick_filters = resouceDef.list.filter.quick_filters;
        }
        if (resouceDef.list.dynamic_filter != undefined)
          this._currentData.currentFilterListFormFields.dynamic_filter = resouceDef.list.dynamic_filter;
        if (resouceDef.list.filter.filterDataFill != undefined) {
          this._currentData.currentFilterListFormFields.filterDataFill = resouceDef.list.filter.filterDataFill;
          this._currentData.currentFilterListFormFields.bannerJson = this._currentData.bannerJson;
        }
      } else {
        this._currentData.currentFilterListFormFields = null;
      }
      //********** BUILDING GRID CONFIG */
      var dataGridConfig = JSON.parse(JSON.stringify(resouceDef.list));
      delete dataGridConfig.filter;
      delete dataGridConfig.fields;
      delete dataGridConfig.bulkAction;
      dataGridConfig.resource = this._currentData.resource;
      dataGridConfig.view_current_data = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.view_current_data != undefined ? this._currentData.resouceDef.config.view_current_data : false;
      dataGridConfig.viewAll = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.viewAll != undefined ? this._currentData.resouceDef.config.viewAll : true;
      dataGridConfig.hideSearchBox = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.hideSearchBox != undefined ? this._currentData.resouceDef.config.hideSearchBox : false;
      dataGridConfig.hideResult = false;
      dataGridConfig.allowPagination = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.allowPagination != undefined ? this._currentData.resouceDef.config.allowPagination : true;
      dataGridConfig.face_recognition = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.face_recognition != undefined ? this._currentData.resouceDef.config.face_recognition : false;

      dataGridConfig.printAll = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.print_all != undefined ? this._currentData.resouceDef.config.print_all : false;
      
      dataGridConfig.readPreference = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.readPreference != undefined ? this._currentData.resouceDef.config.readPreference : false;


      dataGridConfig.autorefresh = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.autorefresh != undefined && this._currentData.resouceDef.config.autorefresh ? this._currentData.resouceDef.config.autorefresh : false;
      dataGridConfig.archive = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.archive != undefined && this._currentData.resouceDef.config.archive ? this._currentData.resouceDef.config.archive : false;
      dataGridConfig.customButtonsAllowed = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.customButtonsAllowed != undefined ? this._currentData.resouceDef.config.customButtonsAllowed : true;
      dataGridConfig.bulk_action_without_checkbox = this?._currentData?.resouceDef?.config?.bulk_action_without_checkbox;
      dataGridConfig.save_filter = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.save_filter != undefined ? this._currentData.resouceDef.config.save_filter : true;
      dataGridConfig.allowConfigGrid = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.configure_grid != undefined ? this._currentData.resouceDef.config.configure_grid : true;
      dataGridConfig.help = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.help != undefined ? this._currentData.resouceDef.config.help : (this.route.snapshot.queryParamMap.get('help_required') != undefined) ? this.route.snapshot.queryParamMap.get('help_required') : true;
      dataGridConfig.ehr_view = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.ehr_view != undefined ? this._currentData.resouceDef.config.ehr_view : false;

      dataGridConfig.ehr_view_default = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.ehr_view_default != undefined ? this._currentData.resouceDef.config.ehr_view_default : false;

      dataGridConfig.secondary_uhid = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.secondary_uhid != undefined ? this._currentData.resouceDef.config.secondary_uhid : false;

      dataGridConfig.secondary_uhid_default = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.secondary_uhid_default != undefined ? this._currentData.resouceDef.config.secondary_uhid_default : false;

      dataGridConfig['projection_keys'] = resouceDef != undefined && resouceDef.list != undefined && resouceDef.list.projectionKeys != undefined ? resouceDef.list.projectionKeys : [];
      dataGridConfig['journey_info'] = resouceDef != undefined && resouceDef.config != undefined && resouceDef.config.journey_info != undefined ? resouceDef.config.journey_info : false;
     
      dataGridConfig['toggle_info'] = resouceDef != undefined && resouceDef.config != undefined && resouceDef.config.toggle_info != undefined ? resouceDef.config.toggle_info : false;
      dataGridConfig['selected_items'] = this._currentData != undefined && this._currentData.selectedItems != undefined ? this._currentData.selectedItems : [];
      dataGridConfig['decorator'] = this._currentData.decorator ? this._currentData.decorator : ''
      dataGridConfig.aiSummary = {}
      this._currentData.dataGridConfig = dataGridConfig;

      /******** AI SUMMARY ****************/
      this.aiService.checkIfAIAvailable(resouceDef, [AIService.GRID_SUMMARY,AIService.CUSTOM_MIS], (aiResp) => {
        if (resouceDef.config?.ai != undefined) {
          if (this._currentData.dataGridConfig.aiSummary == undefined) {
            this._currentData.dataGridConfig.aiSummary = {};
          }
          this._currentData.dataGridConfig.aiSummary.resourceDef = aiResp;
          this._currentData.dataGridConfig.aiSummary.dynamic_key = aiResp.resource;
          this._currentData.dataGridConfig.aiSummary.filter = "";
          this._currentData.dataGridConfig.aiSummary.configLoaded = true
        }
      })
      /******** AI SUMMARY ****************/
      if(resouceDef.config && !resouceDef.config.tile){
        this._currentData.config.tile = false;
        if (this._currentData.preferenceData != undefined && this._currentData.preferenceData["layout__"] != undefined) { // old data fixed
          this._currentData.preferenceData["layout__"] = 'table'
        }
      }

      this._currentData.dataGridConfig.tile = this._currentData.config.tile;
      this._currentData.dataGridConfig.table = this._currentData.config.table;
      this._currentData.dataGridConfig.page_no = this._currentData.gridData.page_no;
      this._currentData.dataGridConfig.limit = this._currentData.gridData.page_size;
      this._currentData.dataGridConfig.printActions = dataGridConfig.printActions;

      if (dataGridConfig != undefined && dataGridConfig.page_limit != undefined) {
        this._currentData.dataGridConfig['page_limit'] = dataGridConfig.page_limit;
      }
      if (this._currentData && this._currentData.list && this._currentData.list.main_table_class) {
        this._currentData.dataGridConfig.main_table_class = this._currentData.list.main_table_class;
      }

      


      if (this._currentData && this._currentData.currentFilterListFormFields && this._currentData.currentFilterListFormFields.blocks && this._currentData.currentFilterListFormFields.blocks.list && this._currentData.currentFilterListFormFields.blocks.list.filter && this._currentData.currentFilterListFormFields.blocks.list.filter.decorator) {
        this._currentData.currentFilterListFormFields.blocks.decorator = this._currentData.currentFilterListFormFields.blocks.list.filter.decorator
      }

      if (this._currentData.uiConfigData != undefined && this._currentData.uiConfigData) {
        dataGridConfig.uiConfigData = this._currentData.uiConfigData;
      }

      /******************* Persisting Filter ***************/
      var filterObj = this.getFilterLabel();
      if (filterObj && filterObj["filterLabel"] != undefined) {
        this._currentData.dataGridConfig.filterLabel = filterObj["filterLabel"];
      }

      if (filterObj && filterObj["search"] != undefined) {
        this._currentData.dataGridConfig.f__search = filterObj["search"];
        if (filterObj["search"] && this._currentData.resouceDef != undefined && this._currentData.resouceDef.proxy_key != undefined && this._currentData.resouceDef.proxy_key) {
          this.storageService.getData('proxy_key' + this._currentData.resource, (data_) => {
            if (data_) {
              this._currentData.dataGridConfig.f__search = data_;
            }
          });
          // this.storageService.removeData('proxy_key'+this._currentData.resource, () => { });
        }
      }

      if (filterObj && filterObj["search_columns"] != undefined) {
        this._currentData.dataGridConfig.f__search_columns = filterObj["search_columns"];
      }
      if (filterObj && filterObj["searchColumns"] != undefined) {
        this._currentData.dataGridConfig.f__searchColumns = filterObj["searchColumns"];
      }
      if (filterObj && filterObj["searchLabel"] != undefined) {
        this._currentData.dataGridConfig.f__searchLabel = filterObj["searchLabel"];
      }
      if (filterObj && filterObj["filterName"] != undefined) {
        this._currentData.dataGridConfig.f__filterName = filterObj["filterName"];
      }
      /*******************Persisting Filter ***************/

      this._currentData.dataGridConfig['showBanner'] = this._currentData.showBanner != undefined && this._currentData.showBanner ? resouceDef.config != undefined && resouceDef.config['hidePrintBanner'] != undefined && resouceDef.config['hidePrintBanner'] ? false : this._currentData.bannerJson : false;
      // /******************* ACCOUNT AWARE ***************/
      if (resouceDef.config != undefined && resouceDef.config.account_aware != undefined && this.appService.isFacilityAware()) {
        this._currentData.dataGridConfig.accountAware = resouceDef.config.account_aware;
      }
      // /******************* ACCOUNT AWARE ***************/

      /***************RULE ENGINE */
      this._currentData.dataGridConfig.ruleEngine = this._currentData.ruleEngine;
      /***************RULE ENGINE */

      /**************ARCHIVE CONFIG *******/
      if (this._currentData.archiveConfig != undefined) {
        this._currentData.dataGridConfig.archiveConfig = this._currentData.archiveConfig;
      }
      /**************ARCHIVE CONFIG *******/

      if (this._currentData.preferenceData != undefined && this._currentData.preferenceData["layout__"] != undefined) {
        this._currentData.config.activeField = this._currentData.preferenceData["layout__"];
      } else if (this.route.queryParams['value']['layout'] != undefined || null) {
        this._currentData.config.activeField = this.route.queryParams['value']['layout'];
      } else if (this._currentData.config.tile && this._currentData.config.table) {
        this._currentData.config.activeField = this._currentData.config && this._currentData.config.default_view == undefined ? 'table' : this._currentData.config.default_view;
      } else if (this._currentData.config.tile && !this._currentData.config.table) {
        this._currentData.config.activeField = 'tile';
      } else {
        this._currentData.config.activeField = 'table';
      }
      this._currentData.dataGridConfig.activeField = this._currentData.config.activeField;
      this._currentData.dataGridConfig.card_selector = resouceDef.list.card_selector;
      this._currentData.dataGridConfig.card_resource = resouceDef.list.card_resource;

      if (this._currentData.decorator != undefined && this._currentData.decorator && resouceDef.list.complex_search) {
        this._currentData.decorator.complexSearchManipulation(resouceDef.list.complex_search, (val) => {
          if (val) {
            this._currentData.dataGridConfig.complex_search = val;
          }
        });
      } else
        this._currentData.dataGridConfig.complex_search = resouceDef.list.complex_search;
      this._currentData.dataGridConfig.taggable = resouceDef.config != undefined && resouceDef.config.taggable != undefined ? resouceDef.config.taggable : true;

      if (this.route.snapshot.queryParams["filterData"] != undefined && this.route.snapshot.queryParams["filterData"] != "") {
        try {
          this._currentData.dataGridConfig.filterData = JSON.parse(this.route.snapshot.queryParams["filterData"]);

        } catch (e) {

        }
      }
      //********** BUILDING GRID CONFIG */

      if (resouceDef.list.rowClick != undefined) {
        this._currentData.rowClick = resouceDef.list.rowClick;
      }
      if (resouceDef.list.heading != null) {
        this._currentData.cardHeader = resouceDef.list.heading;
      }

      if (resouceDef.list.dynamic_key != undefined) {
        this._currentData.resouceDef.dynamic_key = resouceDef.list.dynamic_key
      }

      if (resouceDef.list.fields != null) {
        this._currentData.currentListFields = resouceDef.list.fields;

        //for card layout
        //this work for taggable rows
        if (this._currentData.dataGridConfig.taggable && !this._currentData.currentListFields.find(x => x.heading != undefined && x.heading == "field.label.tag" && x.name != undefined && x.name == "tag_data" && x.type != undefined && x.type == 'array')) {
          this._currentData.currentListFields.push({
            "heading": "field.label.tag",
            "card_tag": null, "type": "array",
            "format": "fn=function(item){var str=''; return str= item['visible']!=undefined && (item['visible']==true ||item['visible']=='true' )? str+item['key_name']+':'+ item['key_value_display']:''}",
            "order": this._currentData.currentListFields.length,
            "name": "tag_data"
          })
        }

        if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.config && this._currentData.resouceDef.config.care_type && this._currentData.resouceDef.config.care_type.auto_column && this._currentData.currentListFields && this._currentData.currentListFields.find(x => x.universal_config_enabled)) {
          this._currentData.currentListFields.find(x => x.universal_config_enabled)["order"] = this._currentData.currentListFields.length - 1
        }

        console.log("this._currentData.currentListFields ", this._currentData.currentListFields);

      } else {
        delete this._currentData.currentCardFields;
      }
      if (resouceDef.list.bulkAction) { // This for bulk action
        this._currentData.bulkAction = resouceDef.list.bulkAction;
         if (resouceDef.list.bulkAction.permission_required) {
          try {
            if (resouceDef.list.bulkAction.actions.length > 0) {
              const hasPermissionRequiredActions = resouceDef.list.bulkAction.actions.some(
                action => action.permission_required === true
              );
              if (!hasPermissionRequiredActions) {
                delete this._currentData.bulkAction;
              } else {
                const allowedActions = resouceDef.list.bulkAction.actions.filter(el => {
                  if (el.permission_required) {
                    return this.rolePermissionService.checkAccessPermission(
                      el.action,
                      el.resource,
                      el.application
                    );
                  }
                  return true;
                });
                if (!allowedActions.length) {
                  // no action left after permission filtering -> hide the whole bar,
                  // otherwise the grid still renders the row checkboxes (bulkActionsConfig is truthy)
                  delete this._currentData.bulkAction;
                } else {
                  this._currentData.bulkAction = { ...resouceDef.list.bulkAction, actions: allowedActions };
                }
              }
            }
          } catch (error) {
            console.warn("err fetching bulk permissions--", error);
          }
        }
      }
    }

    if (resouceDef.card != null) {
      this._currentData.currentCardFields = resouceDef.card; //for card layout
    } else {
      delete this._currentData.currentCardFields;
    }

    this._currentData.addAllowed = (resouceDef.config != undefined && resouceDef.config.add_required != undefined) ? resouceDef.config.add_required : this._currentData.addAllowed;
    this._currentData.upload_csv_config = (resouceDef.config != undefined && resouceDef.config.upload_csv_config != undefined) ? resouceDef.config.upload_csv_config : false;

    //set Location Aware
    this._currentData.location_aware = (resouceDef.config != undefined && resouceDef.config.location_aware != undefined) ? resouceDef.config.location_aware : true;
    this.appService.setLocationAwareConfig(this._currentData.location_aware);

    //Tab data retain issue
    // if (this._layout_id && this._layout_data[this._layout_id] != undefined && this._layout_data[this._layout_id]['grid_data'] != undefined) {
    //   this._currentData.gridData = this._layout_data[this._layout_id]['grid_data'];
    // }

    if (resouceDef.args != undefined && resouceDef.args) {
      if (this.bannerJson && this.bannerJson != undefined) {
        this._currentData.bannerJson = this.bannerJson;
      }
      if (this._currentData.bannerJson != undefined && Object.keys(this._currentData.bannerJson).length > 0 && (this.route.snapshot.queryParams.key != undefined || this.arg_key != undefined || this.route.snapshot.queryParams.query_params != undefined)) {
        this.getArgs(resouceDef, this._currentData.bannerJson, (response) => {
          this._currentData.gridData['args'] = response;
          this.getDataforUiEngine(resouceDef);
        });
      } else {
        let resp = resouceDef.args[0];
        let argForQuery = "";
        for (let i = 0; i < Object.keys(resp).length; i++) {
          argForQuery = argForQuery + Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]] + ","
        }
        this._currentData.gridData['args'] = argForQuery.substring(0, argForQuery.length - 1);
        this.getDataforUiEngine(resouceDef);
      }
    } else {
      this.getDataforUiEngine(resouceDef);
    }
    if (resouceDef?.config?.gridPopup) {   // recent patient history in emr click  method
      this._currentData.dataGridConfig.gridPopupIcon = resouceDef?.config?.gridPopupIcon
      this.gridPopupConfigCheck()
    }
    if(resouceDef?.config?.direct_booking_toggle_button){
      this._currentData.dataGridConfig.direct_booking_toggle_button = resouceDef?.config?.direct_booking_toggle_button
    }
  }

  getParamValueQueryString(paramName, callback) {
    if (this.route.snapshot.queryParams.key == undefined) {
      const url = window.location.href;
      let paramValue;
      if (url.includes('?')) {
        const httpParams = new HttpParams({ fromString: url.split('?')[1] });
        paramValue = httpParams.get(paramName);
      }
      if (paramValue != null)
        callback(paramValue);
      else
        callback(false);
    } else {
      callback(this.route.snapshot.queryParams.key)
    }
  }

  getFilter() {
    this._currentData.gridData['filter'] = '';
    if (this._layout == 'tab') {
      if (this._layout_data?.[this._layout_id]?.['data']?.['filter']) {
        this._currentData.gridData['filter'] = this._layout_data[this._layout_id]['data']['filter'];
      } else {
        this.checkFilterConditions();
      }
    } else if (this.filter != undefined) {
      this._currentData.gridData['filter'] = this.filter;
    } else {
      this.checkFilterConditions();
    }
  }



  getFilterLabel() {
    console.log("========getFilterLabel===============");
    if (this.persistGrid()) {
      try {
        var snapshot = this.activatedRoute.snapshot;
        var filterSaveKey = "f__k";
        var params = { ...snapshot.queryParams };
        if (params[filterSaveKey] != undefined && params[filterSaveKey]) {
          var filterObj = this.storageService.getSessionStorageDataSync(filterSaveKey + "_" + this._currentData.resouceDef.resource);
          if (filterObj) {
            if (filterObj["key"] != undefined && filterObj["key"] == params[filterSaveKey]) {
              return filterObj;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }

  }

  checkFilterConditions() {
    if (this._currentData.resouceDef.filter != undefined && this._currentData.resouceDef.filter) {
      let resp = this._currentData.resouceDef.filter[0];
      var obj = [];
      for (let i = 0; i < Object.keys(resp).length; i++) {
        {
          obj.push(Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]]);
        }
      }
      obj.toString();
      this._currentData.gridData['filter'] = this.getFilterValues(obj.toString());
    } else if (this._currentData.resouceDef.list && this._currentData.resouceDef.list.APIresource && this._currentData.resouceDef.list.APIresource.datasource && this._currentData.resouceDef.list.APIresource.datasource.filter) {
      this._currentData.gridData['filter'] = this.getFilterValues(this._currentData.resouceDef.list.APIresource.datasource.filter);
    }
  }

  initConfigForForm(resource_def) {
    this._currentData.configForm = {
      "submitButton": true,
      "cancelButton": true,
      "filterForm": false,
      "clearOnSave": resource_def.config && resource_def.config.clearOnSave ? resource_def.config.clearOnSave : false,
      "delegateSave": true,
      "cancelRoute": '',
      "floating_button": resource_def.config && resource_def.config.floating_button ? resource_def.config.floating_button : false,
      'delta_update': resource_def.config && resource_def.config.delta_update ? resource_def.config.delta_update : false,
      "id": this._currentData.resouceDef.resource,
      "isTemplate": resource_def.config && resource_def.config.isTemplate ? resource_def.config.isTemplate : false,
      "isExpendRequired": resource_def.config && resource_def.config.isExpendRequired ? resource_def.config.isExpendRequired : false,
      "barcode": resource_def && resource_def.config && resource_def.config.barcode_config ? resource_def.config.barcode_config : false,
      "relayInfo": resource_def && resource_def.config && resource_def.config.relay_info ? resource_def.config.relay_info : false,
      "QrCodeScan": resource_def && resource_def.config && resource_def.config.QrCodeScan ? resource_def.config.QrCodeScan : false,
      "QrCodeSchema": resource_def && resource_def.QrCodeSchema ? resource_def.QrCodeSchema : {},
      "AbhaAdd": resource_def && resource_def.config && resource_def.config.AbhaAdd ? resource_def.config.AbhaAdd : false,
      "resource_config": resource_def && resource_def.config != undefined ? resource_def.config : {},
    }
  }
  getDataforUiEngine(resouceDef, callback = null) {
    this.baseService.init(resouceDef.resource);
    if (this._currentData.currentAction) {
      this.routeParamsSubscription.unsubscribe();
      this.routeParamsSubscription = new Subscription();
      const paramsSub = this.route.params.subscribe(v => {
        if (v.foreign_id != undefined) {
          if (this._currentData.foreignIdFound == undefined) {
            this._currentData.foreignIdFound = 0;
          }

          this._currentData.currentForeignId = v.foreign_id;
          if (this._currentData.currentAction === 'ADD' && this.route.snapshot.data.foreign_id && this._currentData.currentForeignId) {
            this._currentData.currentData = {};
            this._currentData.currentData[this.route.snapshot.data.foreign_id] = this._currentData.currentForeignId;
          }
          if (this.route.snapshot.data.hasOwnProperty('foreign_id')) {
            this._currentData.foreignKeyData[this.route.snapshot.data.foreign_id] = this._currentData.currentForeignId;
          }

          if (this._currentData.foreignIdFound) {
            this.baseService.reloadCurrentRoute();
          } else {
            this._currentData.foreignIdFound = this._currentData.foreignIdFound + 1;
          }
        }
      });
      this.routeParamsSubscription.add(paramsSub);
      if (this._currentData.currentAction === 'ADD') {
        this.initConfigForForm(resouceDef);
      } else if (this._currentData.currentAction === 'MODIFY' || this._currentData.currentAction === 'VIEW') {
        this.initConfigForForm(resouceDef);
        //pharmacy //added as if data will be set by parent component than no need to call api
        if (this._layout == 'simple' && !this._currentData.currentData) {
          this.route.params.subscribe(v => {
            if (v.id != undefined) {
              this._currentData.currentId = v.id;
              if (this._currentData.currentFormFields.datasource != undefined) {
                this.getByQueryID();//in case of custom datasource while getting the data.
              } else {
                this.getByID();
              }

            } else {
              //TODO: get id from input here
              if (this._currentData.resouceDef && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.popUp_action == 'VIEW' && this._currentData.currentFormFields && this._currentData.currentFormFields.datasource != undefined) {
                this.getByQueryID();//in case of custom datasource while getting the data.
              }
            }
          });
        } else {
          let apiObj = JSON.parse(JSON.stringify(this._layout_data[this._layout_id] != undefined && this._layout_data[this._layout_id]['data'] != undefined ? this._layout_data[this._layout_id]['data']['datasource'] : ""));
          if (apiObj['args'] != undefined)
            apiObj['args'] = this.baseService.buildDyanamicStr(apiObj.args, { data: this._currentData.bannerJson.key ? this._currentData.bannerJson.key : this._currentData.bannerJson.existing_data });
          if (apiObj['filter'] != undefined)
            apiObj['filter'] = this.baseService.buildDyanamicStr(apiObj.filter, { data: this._currentData.bannerJson.key ? this._currentData.bannerJson.key : this._currentData.bannerJson.existing_data });
          //pharmacy //added as if data will be set by parent component than no need to call api
          if (!this._currentData.currentData) {
            this.getByQueryID(apiObj);
          }
        }
      } else if (this._currentData.currentAction === 'LIST') {
        if (resouceDef.list && resouceDef.list.gridButtons != undefined) {
          if (this._currentData.currentListFields.find(elem => (elem.name == 'gridButton')) == undefined) {
            resouceDef.list.gridButtons.name = "gridButton";
            this._currentData.currentListFields.push(resouceDef.list.gridButtons);
          }
        }
        if (this._currentData.dataGridConfig.taggable && resouceDef.capability != undefined && resouceDef.capability.length != undefined && resouceDef.capability.length > 0 && !resouceDef.capability.find(x => x.selector != undefined && x.selector == 'tag-row') && this.rolePermissionService.checkAccessPermission('taggable', this._currentData.resource, this._currentData.application)) {
          try {
            resouceDef.capability.push({
              "action": "popup_form",
              "selector": "tag-row",
              "config": resouceDef.config != undefined && resouceDef.config ? resouceDef.config : false,
              "label": "field.label.tagRow",
              // "refersh_grid": true,
              "popup": {
                "title": "Add Tag",
                "size": "lg"
              },
              "permission_required": false
            });
          } catch (error) {
            console.log(error);
          }

        }

        if (this._currentData.currentListFields && this._currentData.currentListFields.length > 0 && resouceDef.config && resouceDef.config.projection_keys) {
          if (this._currentData.archiveConfig != undefined && this._currentData.archiveConfig.selected != undefined && this._currentData.archiveConfig.selected.select_all != undefined && this._currentData.archiveConfig.selected.select_all) {
            this._currentData.gridData.projectionKeys = [];
          } else if (!resouceDef.config.dynamicProjection) {
            this._currentData.gridData.projectionKeys = this.baseService.getProjectionKeys(this._currentData.currentListFields, resouceDef.list.projectionKeys);
          }
        }

        this._currentData.currentListFields = this.rolePermissionService.getAllowedContextMenu(this._currentData.currentListFields, resouceDef.capability, resouceDef.resource);
        this.preferenceService.addActionMenuToLast(this._currentData.currentListFields);
        this._currentData.currentListFields = this._currentData.currentListFields.sort((a, b) => { return a.order - b.order });
        if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.decorator.processFieldsList != undefined) {
          this._currentData.decorator.processFieldsList(this._currentData, (dataR) => {
            this._currentData.currentListFields = dataR;
          })
        }
        this._currentData.legend = resouceDef.list?.legends;
        this._currentData.extra_buttons = resouceDef.list?.extra_buttons;
        this._currentData.showView = true;
        if (this._currentData.currentCardFields) {
          this._currentData.cardClassName = this._currentData.currentCardFields.className;
          this._currentData.currentCardFields = this.rolePermissionService.getAllowedContextMenu(this._currentData.currentCardFields, resouceDef.capability, resouceDef.resource);
        }
        if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.list && this._currentData.resouceDef.list['limit']) {
          var grid_list = this._currentData.resouceDef.list['limit'];
          this._currentData.gridData.page_size = grid_list//todo incase of there is queryparam of limit in url
        }
        else if (this._currentData.gridData.page_size == undefined) {
          this._currentData.gridData.page_size = 10;
        }
        var bindGridNotFired = true;
        if (this._currentData.resouceDef.list != undefined && this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
          this._currentData.APIresource = this._currentData.resouceDef.list.APIresource.datasource;
          if (this._currentData.APIresource.search)
            this._currentData.gridData['search'] = this._currentData.APIresource.search;
          this.getOrderBy();
          if (this._currentData.gridData.args) {
            let argsVal = this._currentData.gridData.args;
            argsVal = argsVal.toString().replace('!!!uhId!!!', localStorage.getItem('hasUhId')); //change for sanjay sir
            if (this.appService.getOrganization()) {
              argsVal = argsVal.replace('!!!facility_id!!!', this.appService.getOrganization().org_id);
            }
            this._currentData.gridData['args'] = argsVal;
          }
          if (this._currentData.APIresource.filter) { // Need to review
            this._currentData.gridData['filter'] = this.getFilterValues(this._currentData.APIresource.filter)
            console.log("inside filter ", this._currentData.gridData['filter'])
          }
          if (this._currentData.APIresource.args) {
            if (this._currentData.bannerJson != undefined && this._currentData.bannerJson.key != undefined) {
              this._currentData.gridData['args'] = this.baseService.buildDyanamicStr(this._currentData.APIresource.args, { 'data': this._currentData.bannerJson.key });
            } else if (this._currentData.resouceDef && this._currentData.resouceDef.config && this._currentData.resouceDef.config.checkUrlArgs) {
              this._currentData.gridData['args'] = this.baseService.buildDyanamicStr(this._currentData.APIresource.args, { 'data': this.activatedRoute.snapshot.queryParams });
            } else if (this._currentData.resouceDef && this['data']) {
              this._currentData.gridData['args'] = this.baseService.buildDyanamicStr(this._currentData.APIresource.args, { 'data': this['data']});
            } else {
              this._currentData.gridData['args'] = this.baseService.buildDyanamicStr(this._currentData.APIresource.args, { 'data': {} });
            }
            this._currentData.gridData['args'] = this.baseService.checkargs(this._currentData.gridData['args'])
          }
          if (this._currentData.APIresource.query_id)
            this._currentData.query_id = this._currentData.APIresource.query_id;
          if (!this._currentData.default_filter && resouceDef.list && resouceDef.list.dynamic_filter == undefined) {
            //call bindgrid if default sorted & dynamic filter is not available otherwise it will get called automatically
            if (!(this._currentData.dataGridConfig != undefined && this._currentData.dataGridConfig.default_sorted != undefined)) {
              this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
            }
          }
        } else {
          this.getOrderBy();
          if (!this._currentData.default_filter && resouceDef.list && resouceDef.list.dynamic_filter == undefined) {
            //call bindgrid if default sorted & dynamic filter is not available otherwise it will get called automatically
            if (!(this._currentData.dataGridConfig != undefined && this._currentData.dataGridConfig.default_sorted != undefined)) {
              bindGridNotFired = false;
              this.bindGrid();
            }
          }
        }
        if (bindGridNotFired && this._currentData.dataGridConfig != undefined && this._currentData.dataGridConfig.filterLabel != undefined) {
          this.bindGridFn();
        }
      } else if (this._currentData.currentAction === 'FORM_GRID') {
        if (this._currentData.resouceDef.list != undefined && this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
          this._currentData.APIresource = this._currentData.resouceDef.list.APIresource.datasource;
        }
      }
      if (resouceDef.config != undefined) {
        this._currentData.config.tile = (resouceDef.config.tile != undefined) ? resouceDef.config.tile : this._currentData.config.tile;
        this._currentData.config.table = (resouceDef.config.table != undefined) ? resouceDef.config.table : this._currentData.config.table;

        this._currentData.dataGridConfig.tile = this._currentData.config.tile;
        this._currentData.dataGridConfig.table = this._currentData.config.table;
        if (this.route.queryParams['value']['layout'] != undefined || null) {
          this._currentData.config.activeField = this.route.queryParams['value']['layout'];
        } else if (this._currentData.preferenceData != undefined && this._currentData.preferenceData["layout__"] != undefined) {
          this._currentData.config.activeField = this._currentData.preferenceData["layout__"];
        } else if (this._currentData.config.tile && this._currentData.config.table) {
          this._currentData.config.activeField = resouceDef.config && resouceDef.config.default_view == undefined ? 'table' : resouceDef.config.default_view;
        } else if (this._currentData.config.tile && !this._currentData.config.table) {
          this._currentData.config.activeField = 'tile';
        } else {
          this._currentData.config.activeField = 'table';
        }

        this._currentData.dataGridConfig.disableCapability = (resouceDef.config.disable_capability != undefined) ? resouceDef.config.disable_capability : false;

        console.log("this._currentData.config.disableCapability==>", this._currentData.config.disableCapability);


        this._currentData.dataGridConfig.activeField = this._currentData.config.activeField;
        this._currentData.dataGridConfig['bannerJson'] = this._currentData.bannerJson != undefined && this._currentData.bannerJson ? this._currentData.bannerJson : "";
        this._currentData.dataGridConfig['showBanner'] = this._currentData.showBanner != undefined && this._currentData.showBanner ? resouceDef.config != undefined && resouceDef.config['hidePrintBanner'] != undefined && resouceDef.config['hidePrintBanner'] ? false : this._currentData.bannerJson : false;
        this._currentData.dataGridConfig['sorting_persisted'] = this._currentData.sorting_persisted ? this._currentData.sorting_persisted : false;
        this._currentData.dataGridConfig['FrontDefaultSort'] = resouceDef.config != undefined && resouceDef.config.front_default_sort != undefined ? resouceDef.config.front_default_sort : false;
        this._currentData.dataGridConfig['master_upload'] = resouceDef.config != undefined && resouceDef.config.master_upload != undefined ? resouceDef.config.master_upload : false;
        if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.decorator.processDataGridConfig != undefined) {
          this._currentData.decorator.processDataGridConfig(this._currentData.dataGridConfig, (dataR) => {
            this._currentData.dataGridConfig = dataR;
          })
        }
      }
    }
    if (callback)
      callback(true);
    // this.loader.hideSpinner();
  }
  getBannerData(event) {
    this.bannerData = event;
    this._currentData.bannerJson.key = event;
    this._currentData.bannerJson.existing_data = event;
  }
  getArgs(resouceDef, bannerJson, callback) {
    var id = this.route.snapshot.queryParams.key != undefined ? this.route.snapshot.queryParams.key : this.arg_key;
    var bannerArgs = '';
    if (this.route.snapshot.queryParams && this.route.snapshot.queryParams.query_params)
      bannerArgs = this.route.snapshot.queryParams.query_params;
    else if (bannerJson.datasource['args'] == undefined)
      bannerArgs = "id:" + id;
    else if (id != undefined)
      bannerArgs = bannerJson.datasource['args'] + ",id:" + id;
    else {
      if (resouceDef.args) {
        let resp = resouceDef.args[0];
        let argForQuery = "";
        for (let i = 0; i < Object.keys(resp).length; i++) {
          argForQuery = argForQuery + Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]] + ","
        }
        callback(argForQuery.substring(0, argForQuery.length - 1));
      }
      else {
        callback('');
      }
    }
    if (bannerJson.key != undefined) {
      this._currentData.showBanner = true;
      if (Array.isArray(resouceDef.args)) {
        let resp = resouceDef.args[0];
        let argForQuery = "";
        for (let i = 0; i < Object.keys(resp).length; i++) {
          if (resp[Object.keys(resp)[i]] == '' || resp[Object.keys(resp)[i]] == undefined) {
            argForQuery = argForQuery + Object.keys(resp)[i] + ":" + bannerJson.key[Object.keys(resp)[i]] + ","
          } else {
            argForQuery = argForQuery + Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]] + ","
          }
        }
        callback(argForQuery.substring(0, argForQuery.length - 1));
      } else {
        callback('');
      }
    }
    else {
      this.baseService.get(bannerJson.datasource.query_id, bannerArgs, bannerJson.datasource.resource, bannerJson.datasource.application).subscribe((res: any) => {
        console.log("data in response in banner detail is :: ", res);
        if (res.errCode == -1) {
          callback('');
        } else {
          if (res.resource != null && res.resource.length > 0) {
            res = res.resource[0];
            this._currentData.bannerJson.key = res;
            this._currentData.bannerJson.existing_data = res;
            this._currentData.showBanner = true;
            if (Array.isArray(resouceDef.args)) {
              let resp = resouceDef.args[0];
              let argForQuery = "";
              for (let i = 0; i < Object.keys(resp).length; i++) {
                if (resp[Object.keys(resp)[i]] == '' || resp[Object.keys(resp)[i]] == undefined) {
                  argForQuery = argForQuery + Object.keys(resp)[i] + ":" + res[Object.keys(resp)[i]] + ","
                } else {
                  argForQuery = argForQuery + Object.keys(resp)[i] + ":" + resp[Object.keys(resp)[i]] + ","
                }
              }
              callback(argForQuery.substring(0, argForQuery.length - 1));
            } else {
              callback('');
            }
          } else {
            callback('');
          }
        }
      });
    }
  }

  getPayemntDetails() { //change here to get payment Detail

  }

  getSummaryResponse(event) {
    if (event && event.summaryResponse) {
      this._currentData.summaryResponse = event.summaryResponse;
    } else {
      this._currentData.summaryResponse = {};
    }

  }

  resetFilterKey(nevigate = true) {
    if (this.persistGrid()) {
      try {
        delete this._currentData.dataGridConfig.filterLabel;
        delete this._currentData.filterPrintInfo;
        delete this._currentData.filterPrintInfo;

        if (this._currentData.gridData != undefined && this._currentData.gridData['noRule'] != undefined) {
          delete this._currentData.gridData['noRule']
        }

        var snapshot = this.activatedRoute.snapshot;
        var filterSaveKey = "f__k";
        var params = { ...snapshot.queryParams };
        delete params[filterSaveKey];
        delete this._currentData.saveFilterKey;
        this.storageService.removeSesssionData(filterSaveKey + "_" + this._currentData.resouceDef.resource);
        if (this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.eg_json != undefined) {
          this.storageService.removeSesssionData(filterSaveKey + "_eg" + this._currentData.resouceDef.config.eg_json);
        }
        // if (this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.eg_json != undefined){
        //for track sample
        try {
          this.storageService.removeSesssionData('f__k' + "_ts" + this._currentData.resouceDef.resource);
          this.storageService.removeData('filterConfig' + this._currentData.resouceDef.resource, () => { });
          this.storageService.removeData('filterFormMapping' + this._currentData.resouceDef.resource, () => { });
          this.storageService.removeData('filterName' + this._currentData.resouceDef.resource, () => { });
          this.storageService.removeData('filterSavedVal' + this._currentData.resouceDef.resource, () => { });
          this.storageService.removeData('filterFormGroup' + this._currentData.resouceDef.resource, () => { });
          this.storageService.removeSesssionData('f__k' + "_eg" + this._currentData.resouceDef.resource);
        } catch (error) {

        }

        // }


        if (nevigate) {
          var url = this.router.createUrlTree([], { relativeTo: this.route, queryParams: params, queryParamsHandling: '' }).toString()
          this.locationCommon.replaceState(url);
          //this.router.onSameUrlNavigation = 'ignore';
          this.router.navigate(['.'], { relativeTo: this.route, queryParams: params, replaceUrl: true, queryParamsHandling: '' });//(uncommenting because router params was not updating)
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  getConfigValues(event) {
    if (event.resetFilter != undefined && event.resetFilter) {
      var gridData = this._currentData.gridData;
      if (gridData.search != undefined && gridData.search) {
        //dont delete the saved filter
        this.saveFilterObj({ gridData: gridData }, (responseConfig) => {

        });
      } else {
        this.resetFilterKey();
      }
    } else if (event.changePage != undefined) {
      this._currentData.gridData.page_no = event.changePage;
    } else if (event.loadArchiveConfig != undefined) {
      this._currentData.archiveConfig.list = event.loadArchiveConfig.list;
    } else if (event.archiveConfig != undefined) {
      let archiveConfig: any = false
      if (event.archiveConfig != undefined && this._currentData.archiveConfig != undefined) {
        archiveConfig = this._currentData.archiveConfig;
      }
      this._currentData = false;
      setTimeout(() => {
        this._currentData = {};
        if (archiveConfig) {
          archiveConfig.open = false;
          this._currentData.archiveConfig = archiveConfig;
        }
        this.uiInit(event);
      })

    } else if (event.configureGrid != undefined) {
      this.configUIEngine(event.configureGrid);
    } else if (event.getCount != undefined) {
      if (this._currentData.resouceDef.config == undefined) {
        this._currentData.resouceDef.config = {};
      }
      this._currentData.resouceDef.config.noCount = false;
    } else if (event.loadSavedFilter != undefined) {
      this._currentData.loadSavedFilter = true;
    } else if (event.filterPrintInfo != undefined && event.filterPrintInfo) {
      this._currentData.filterPrintInfo = event.filterPrintInfo;
      this._currentData.saveFilterKey = true;
    }
    else if (event != undefined && event.filterName) {
      this._currentData.gridData['filterName'] = event.filterName;
    }
    else if (event != undefined && event.hasOwnProperty('filterType')) {
      this._currentData.gridData['filterType'] = event.filterType;
    } else if (event != undefined && event.hasOwnProperty('archiveChange')) {
      if (event.config != undefined && event.config.resource != undefined) {
        this._currentData.resouceDef.config.archive.isON = event.archiveChange;
        if (event.archiveChange) {
          event.config.origResource = this._currentData.resource;
          this._currentData.origArhiveConfig = event.config;
          this._currentData.json = event.config.resource;
          this._currentData.resource = event.config.resource;
        } else {
          this._currentData.json = this._currentData.origArhiveConfig.origResource;
          this._currentData.resource = this._currentData.origArhiveConfig.origResource;
          delete this._currentData.origArhiveConfig;
        }
        this._currentData.render_template = false;
        setTimeout(() => {
          this._currentData.render_template = true;
          this.ngOnInit();
        });
      }
    }
  }

  getConfigurationKey(config) {
    var resourceName = this._currentData.json;
    if (config.context == 'grid') {
      resourceName = this._currentData.resouceDef.resource;
    }
    return this.preferenceService.getConfigurationKey(resourceName);
  }


  getTableConfig(callback, account?, config?) {
    var key = this.getConfigurationKey(config);
    // if (account) {
    //     key = 'account__' + key;
    // }
    this.preferenceService.getUserPreferenceConfig(key, (data) => {

      callback(data);
    });
  }

  configUIEngine(config) {
    var obj: any = {};
    obj = { ...obj, ...config };
    obj["key"] = this.getConfigurationKey(config);
    obj["resource_name"] = this._currentData.json;
    if (config.context == 'grid') {
      obj["resource_name"] = this._currentData.resouceDef.resource;
    }
    if (this._currentData?.dynamic_conf_columns?.length > 0)
      obj['dynamic_conf_columns'] = this._currentData['dynamic_conf_columns'];
    this.preferenceService.openConfigurePopup(obj, (response) => {
      if (response.result != undefined) {

        this.preferenceService.saveConfigurationData(obj, response.result, (result) => {
          console.log(result);
        });



      }
    });
  }
  getOrderBy() {
    if (this._currentData.sorting_persisted && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.backendSorting != undefined && this._currentData.resouceDef.config.backendSorting.backendSorting) {
      this._currentData.gridData.order_by = this._currentData.sorting_persisted.key + ' ' + ((this._currentData.sorting_persisted.value == 'desc') ? this._currentData.sorting_persisted.value : '');
    } else if (this._currentData.APIresource && this._currentData.APIresource.order_by)
      this._currentData.gridData['order_by'] = this._currentData.APIresource.order_by;
  }
  bindDataToGrid(event) {
    if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.decorator.processFilter != undefined) {
      event = this._currentData.decorator.processFilter(event, this._currentData);
    }
    if (this.route.snapshot.queryParams["p__no"] == undefined) {
      this._currentData.gridData.page_no = 0;
    }
    this.updatePageInUrl(this._currentData.gridData.page_no);
    // var args = "noCount:1";
    // this._currentData.resouceDef.config.noCount = true;
    // if (this._currentData.gridData.args != undefined && this._currentData.gridData.args != "" && !this._currentData.gridData.args.includes("noCount")) {
    //   this._currentData.gridData.args = this._currentData.gridData.args + ',' + args;
    // } else {
    //   this._currentData.gridData.args = args;
    // }
    if (event == undefined || event == '') {
      this._currentData.gridData['filter'] = '';
      this.getFilter();
      this.getOrderBy();
    }
    else if (event != 'ehr_toggle') {
      this._currentData.gridData['filter'] = '';
      this.getFilter();
      if (this._currentData.gridData['filter'] != "") {
        // This line meant to be if there are default filter and searched filter also. If problem exist consult Aarti
        this._currentData.gridData['filter'] = event + ',' + this._currentData.gridData['filter'];//this line was duplicating the filters and single filter change was not working from grid
      } else {
        this._currentData.gridData['filter'] = event;
      }
      /*************Below function is to remove duplicate key from filter string */
      this._currentData.gridData['filter'] = this.filterService.removeDuplicateKeysFromString(this._currentData.gridData);
    }
    this.bindGridFn();
  }

  bindGridFn() {
    if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.list && this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
      if (this._currentData.APIresource == undefined) {
        this._currentData.APIresource = this._currentData.resouceDef.list.APIresource;
      }
      this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
    } else {
      this.bindGrid();
    }
  }


  selectedItemsData(event) {
    let data = this._currentData.filterList;
    if (data != undefined) {
      let finalData = data.concat(event);
      let listResource: any = {};
      listResource.count = finalData.length;
      listResource.resource = finalData;
      this._currentData.dataList = listResource;
      this._currentData.filterList = finalData;
      this._currentData.showAddButton = true;
    }
  }

  addButtonAction() {
    this._currentData.showAddButton = false;
  }
  closesOverlay(event) {
    console.log("Event is ", event);
    this._currentData.showAddButton = true;
  }
  /*** THIS EVENT IS EMIITED WHEN INPUT SEARCH ITEM IS CLICKED */
  settingUserInfo(item) {
    if (item != undefined) {
      if (this._currentData.addButton.hasOwnProperty('remote_confirm')) {
        this.confirmRemote(item, this._currentData.addButton.remote_confirm, 'addButton');
      } else {
        this.checkingConditions(item);
      }
    }
  }

  checkingConditions(item) {
    if (this._currentData.addButton.hasOwnProperty('conditions')) {
      let flag = true;
      this._currentData.addButton.conditions = this.appService.check_permssion_PRN(this._currentData.addButton.conditions, "check_prn");
      if (this?.appService?._appName == "pharmacy") {
        let registrationCheck = false;
        registrationCheck = this._currentData?.addButton?.fixLabel?.config_name && this.appService.getAccountConfigValue(this._currentData.addButton.fixLabel.config_name) ? true : false;
        if(registrationCheck){
          this._currentData.addButton.conditions.push(this._currentData.addButton.fixLabel.block_prn_obj)
        }
      }
      for (let condition of this._currentData.addButton.conditions) {
        if (eval(condition.expression)) {
          if (condition.action == 'remote_confirm') {
            this.alerts.error(condition.err_message);
            flag = false;
          } else {
            if (this.rolePermissionService.checkAccessPermission(condition.action.action_name, condition.action.resource, condition.action.application) || (condition.action.permission_required != undefined && condition.action.permission_required == false)) {
              flag = false;
              let size = this.baseService.getModalSize(condition.action['popup']['size'] ? condition.action['popup']['size'] : '');
              condition['action']['data'] = item;
              this.smartModalService.open(PopupFormComponent, condition.action, condition.action['popup']['title'], size).subscribe(
                response => {
                  this.redirectToOtherPage(response.result.resource[0]);
                }, err => { }
              );
              break;
            } else {
              flag = true;
            }
          }
        }
      }
      if (flag) {
        this.redirectToOtherPage(item);
      }
    } else {
      this.redirectToOtherPage(item);
    }
  }

  redirectToOtherPage(item, event?) {
    let url = "";
    if (this._currentData.addButton['redirectLink'] && event == undefined) {
      url = this.findroute(this._currentData.addButton['redirectLink']);
    }
    else if (this._currentData.addButton.route_path != undefined && this._currentData.addButton.route_path) {
      //here item is the data of the row
      this.baseService.redirectToOtherPage(this._currentData.addButton.route_path, item);
    }
    else if (this._currentData.addButton.hasOwnProperty('conditions')) {
      for (const element of this._currentData.addButton.conditions) {
        if (element.expression != "" && element.expression != undefined && element.redirectLink != "" && element.redirectLink != undefined) {
          if (eval(element.expression)) {
            url = this.findroute(element.redirectLink);
            break;
          } else {
            url = this.findroute(this._currentData.addButton.fixLabel.popup.redirectLink);
          }
        }
        else {
          url = this.findroute(this._currentData.addButton.fixLabel.popup.redirectLink);
        }
      }
    }
    else {
      url = this.findroute(this._currentData.addButton.fixLabel['popup']['redirectLink']);
    }
    if (this._currentData.addButton.required_rowData || (this._currentData.addButton.fixLabel && this._currentData.addButton.fixLabel['popup'] && this._currentData.addButton.fixLabel['popup']['required_rowData'])) {
      sessionStorage.setItem('currentData', JSON.stringify(item));
    }
    if (url != '') {
      if (this._currentData.addButton.fixLabel && this._currentData.addButton.fixLabel['popup'] && this._currentData.addButton.fixLabel['popup']['queryParams']) {
        var q = { returnUrl: this.router.url, key: item.id };
        for (let s = 0; s < Object.keys(this._currentData.addButton.fixLabel['popup']['queryParams']).length; s++) {
          q[Object.keys(this._currentData.addButton.fixLabel['popup']['queryParams'])[s]] = this._currentData.addButton.fixLabel['popup']['queryParams'][(Object.keys(this._currentData.addButton.fixLabel['popup']['queryParams'])[s])]
        }
        this.router.navigate([url], { queryParams: q });
      } else {
        if (item.hasOwnProperty("ivf_primary") && item.ivf_no) {
          this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: item.patient_id, ivf_no: item.ivf_no } });
        } else
          this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: item.id } });
      }
    }

  }

  findroute(url) {
    if (url == this.router.url) {
      this.ngOnInit();
      return '';
    } else {
      return url;
    }
  }

  /*** THIS EVENT IS EMIITED WHEN INPUT SEARCH LABEL(BUTTON) IS CLICKED */
  InputEvent(event) {
    let label = this._currentData.addButton.fixLabel;
    label.searchText = '';
    if (event != undefined && event.searchField != undefined && event.searchField.key != undefined) {
      label['searchField'] = event.searchField.key;
    }
    if (event.searchText)
      label.searchText = event.searchText; //for get input search text on form
    if (event.qrCodeData)
      label.qrCodeData = event.qrCodeData
    var size = this.baseService.getModalSize(label['popup']['size'] ? label['popup']['size'] : '');
    let registrationCheck = false;
    if (event?.fixLabel?.check_config) {
      registrationCheck = event?.fixLabel?.config_name && this.appService.getAccountConfigValue(event.fixLabel.config_name) ? true : false;
    }
    if (label.check_permission) {
      let _permission = this.appService.checkPermissionforPrn(label.check_permission, "pre_registration", "patient")
      for (let i = 0; i < _permission.length; i++) {
        let permission = this.rolePermissionService.checkAccessPermission(_permission[i].action_name, _permission[i].resource, label.application);
        if (label.permission_required != undefined && label.permission_required == false) {
          label.resource = "patient";
          this.openPopUp(label, size);
          return false
        } else if (permission) {
          label.resource = _permission[i].resource;
          if (registrationCheck) {
            label.resource = "patient";
          }
          this.openPopUp(label, size);
          return false
        }
      }
    } else {
      if (registrationCheck) {
        label.resource = "patient";
      }
      this.openPopUp(label, size);
    }
  }

  openPopUp(label, size) {
    this.smartModalService.open(PopupFormComponent, label, label['popup']['title'], size).subscribe(
      response => {
        if (response != undefined && response.result != undefined && response.result.resource != undefined && response.result.resource.length != undefined && response.result.resource.length > 0) {
          this.redirectToOtherPage(response.result.resource[0], 'popup');
        }
      }, err => { }
    );
  }

  activeTab(key) {
    try {
      this.hasSubscription.unsubscribe();
      this.hasSubscription = new Subscription();
      if(this?.ngZone){
        this?.ngZone?.runOutsideAngular(()=>{
          this.cleanBarcodeListener();
        });
      }
    } catch (error) {}
    
    this.resetFilterKey(true);
    this.filteredLayoutKeys = this._copy_layout_data
    if (this.parent_id != 2 || (this.parent_id == 2 && this._layout_id != key)) { 
      if (this.activeTabTimeout) {
        clearTimeout(this.activeTabTimeout);
        this.activeTabTimeout = null; 
      }
      this._layout_id = key;
      this._currentData.tabClick = true; // For using in other extending components
      var snapshot = this.activatedRoute.snapshot;
      var params = { ...snapshot.queryParams };
      var tab_key = 'tab_' + this.parent_id;
      this._currentData.tabName = key;
      if (this._currentData.tabType == 'vertical' && this._layout_data?.[key]?.data?.name_change) {
        this._currentData.tabLayoutName = this._layout_data?.[key]?.data?.layoutName;
      }else{
        this._currentData.tabLayoutName = undefined;
      }
      params[tab_key] = key;
      /*****reseting past child tab */
      if (this.parent_id == '0' && snapshot.queryParams.tab_1 != undefined) {
        delete params.tab_1;
      }
      if (this.parent_id == '0' && snapshot.queryParams.tab_2 != undefined) {
        delete params.tab_2;
      }
      if (this.parent_id == '0' && snapshot.queryParams.layout != undefined) {
        delete params.layout;
      }
      if (this.parent_id == '1' && snapshot.queryParams.tab_2 != undefined) {
        delete params.tab_2;
      }
      //pagination fix when switching between tabs
      if (this.parent_id == '0' && snapshot.queryParams.p__no != undefined) {
        delete params.p__no;
      }
      /*****reseting past child tab */
      this.router.navigate([], { queryParams: params });
      // var url =this.router.createUrlTree([], { relativeTo: this.route, queryParams:params}).toString()
      // this.locationCommon.replaceState(url);

      this._currentData.render_template = false;
      this._currentData.showView = false;  
      this._currentData.dataList = null;   
      this._currentData.defaultFormData = {};
      if (this._currentData.tabType == 'vertical') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      this.activeTabTimeout = setTimeout(() => {
        this.ngZone.run(() => { 
        this.activeTabTimeout = null;
        delete this._currentData.archiveConfig;
        this._currentData.showView = false;
        this._currentData.addButton = undefined;
        this._currentData.render_template = true;
        this._currentData.query_id = '';
        this._currentData.gridData = {};
        this._currentData.dataList = [];
        this._currentData.decorator = false;
        this._currentData.APIresource = {};
        this._currentData.ruleEngine = {};
        this._currentData.currentListFields = [];
        this._currentData.currentFormFields = {};
        this._currentData.bulkAction = false;
        this._currentData.bookmarks = undefined;
        this._currentData.resouceDef = {};
        this._currentData.rowClick = undefined;
        this._currentData.cardHeader = undefined;
        this._currentData.default_filter = false;
        this._currentData.addAllowed = true;
        this._currentData.currentFormFields.loaded = false;
        this.initLayoutData();
         });
      });
      if (this.utilService.isMobile() && this.sideBarMenuRef != undefined && this.sideBarMenuRef.nativeElement != undefined && this.sideBarMenuRef.nativeElement.classList != undefined && !this.sideBarMenuRef.nativeElement.classList.contains('sidebar-mini-new')) {
        this.sideBarMenuRef.nativeElement.classList.add('sidebar-mini-new');
      }
    }
  }

  updateCurrentDataFromSavedFilter() {
    if (this._currentData.loadSavedFilter != undefined) {
      var filterSavedObj = this.getFilterLabel();
      if (filterSavedObj && filterSavedObj["filter"] != undefined) {
        this._currentData.gridData['filter'] = filterSavedObj["filter"];//apply filter which is in url
      }
      if (filterSavedObj && filterSavedObj["filterLabel"] != undefined) {
        this._currentData.filterPrintInfo = filterSavedObj["filterLabel"];//apply filter which is in url
      }

      if (filterSavedObj && filterSavedObj["search_columns"] != undefined) {
        this._currentData.gridData['search_columns'] = filterSavedObj["search_columns"];//apply filter which is in url
      }

      if (filterSavedObj && filterSavedObj["search"] != undefined) {
        this._currentData.gridData['search'] = filterSavedObj["search"];//apply filter which is in url
      }

      if (filterSavedObj && filterSavedObj["searchColumns"] != undefined) {
        this._currentData.gridData['searchColumns'] = filterSavedObj["searchColumns"];//apply filter which is in url
      }
      if (filterSavedObj && filterSavedObj["searchLabel"] != undefined) {
        this._currentData.gridData['searchLabel'] = filterSavedObj["searchLabel"];//apply filter which is in url
      }
      if (filterSavedObj && filterSavedObj["noRule"] != undefined && filterSavedObj["noRule"] != undefined) {
        this._currentData.gridData['noRule'] = filterSavedObj["noRule"];//apply filter which is in url
      }

      if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
        //do nothing
      } else if (filterSavedObj && filterSavedObj["eq_search"] != undefined) {
        this._currentData.gridData['eq_search'] = filterSavedObj["eq_search"];//apply filter which is in url
      }

      //var filterSaveKey = "f__k";
      delete this._currentData.saveFilterKey;
      delete this._currentData.loadSavedFilter;
      /********TODO PRININFO IMPLEMENT ON PRINT FROM SAVED FILTER *******/
      //this.storageService.removeSesssionData(filterSaveKey+"_"+this._currentData.resouceDef.resource);
    }
  }

  bindGrid(resource?, application?, type?, queryId?, printInfo?, callback = null) {
    this.loader.showSpinner();
    this.updateCurrentDataFromSavedFilter();
    var gridData = JSON.parse(JSON.stringify(this._currentData.gridData));//making a clone
    if (this._currentData.dataGridConfig.secondary_uhid_default) {
      gridData['args'] += "," + 'secondary_uhid:true';
    }
    if (this._currentData.dataGridConfig.secondary_uhid_default) {
      gridData['args'] += "," + 'secondary_uhid:true';
    }
    if (this._currentData.dataGridConfig && this._currentData.dataGridConfig.readPreference)
      gridData['readPreference'] = this._currentData.dataGridConfig.readPreference;
    if (this._currentData.dataGridConfig.ehr_view_default || this.ehr_view_default == true)
      gridData['read_scope_level'] = 'account';
    else if (gridData['read_scope_level'] != undefined)
      delete gridData['read_scope_level'];

    if (this._currentData.parameters) {
      gridData['parameters'] = this._currentData.parameters;
    }

    if (queryId == undefined || queryId == '') {
      gridData['query_id'] = this._currentData.query_id == undefined || this._currentData.query_id == "" ? "GET_PAGE" : this._currentData.query_id;
    } else { gridData['query_id'] = queryId == undefined || queryId == "" ? "GET_PAGE" : queryId; }


    if (this._layout_id && this._layout_data[this._layout_id] != undefined) {
      this._layout_data[this._layout_id]['grid_data'] = gridData;
    }
    if (this.route.snapshot.data.foreign_id != undefined && this.route.snapshot.data.foreign_id && this._currentData.currentForeignId) {  // this line is olny work for View_Details three dot click
      if (gridData.hasOwnProperty('filter') && gridData['filter'] != "") {
        gridData['filter'] += "," + this.route.snapshot.data.foreign_id + ':' + this._currentData.currentForeignId;
      } else {
        gridData['filter'] = this.route.snapshot.data.foreign_id + ':' + this._currentData.currentForeignId;
      }
    }
    try {
      if (this._currentData.summary) {
        this._currentData.summary.hideSummaryButton = false;
      }
    } catch (error) { }

    try {
      if(this.commonServiceUi?.['visibleFields']?.length>0 && this.projectionEnabled){
        gridData["projectionKeys"] = this.commonServiceUi['visibleFields']
      } else if ((this._currentData.gridData && this._currentData.gridData.projectionKeys) || (gridData.printInfo.actionType == "downloadCSV")) {
        gridData['projectionKeys'] = this._currentData.gridData.projectionKeys.toString();
      }
    } catch (error) { }

    if (gridData.order_by && gridData.search && gridData.search != undefined)
      delete gridData.order_by;

    //implementing print
    if (printInfo) {
      if (printInfo.contentType != 'byte_array') {
        printInfo.responseType = "blob";
        var gridTemplate = 'grid';
        if (printInfo.gridInfo != undefined && printInfo.gridInfo && printInfo.gridInfo.length > 0) {
          let isTat = printInfo.gridInfo.find(s => s.name == 'tat');
          var tat = isTat != undefined && isTat ? [isTat.name] : [];
        }
        if (this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.grid_template != undefined && this._currentData.resouceDef.config.grid_template != "") {
          gridTemplate = this._currentData.resouceDef.config.grid_template;
        }
        if (printInfo.print_data != undefined && printInfo.print_data == "grid" && printInfo.template != undefined) {
          gridTemplate = printInfo.template;
        }
        if (printInfo.args && printInfo.args != undefined) {
          var args = "reportTemplateId:" + gridTemplate + ",contentType:" + printInfo.file_type + "," + printInfo.args;
        }
        else {
          var args = "reportTemplateId:" + gridTemplate + ",contentType:" + printInfo.file_type;
        }
        if (this.appService.getCurrentLocation() && this.appService.getCurrentLocation().location_id != undefined) {
          args = args + ',location_id:' + this.appService.getCurrentLocation().location_id;
        }
        if (printInfo.actionType != undefined && ["downloadCSV", "download"].indexOf(printInfo.actionType) > -1) {
          args = args + ',downloadCSV:true';
        }
        if (printInfo.download_only != undefined && printInfo.download_only) {
          args = args + ',downloadOnly:true';
        }
        if (printInfo.chunk_download != undefined && printInfo.chunk_download) {
          args = args + ',chunk_download:true';
        }
        if (printInfo.chunk_size != undefined && printInfo.chunk_size) {
          args = args + ',chunk_size:' + printInfo.chunk_size;
        }

        if (this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.exclude_fields != undefined && this._currentData.resouceDef.config.exclude_fields.length > 0) {
          printInfo.excludeFields = this.concatExcludeFieldFn(tat, this._currentData.resouceDef.config.exclude_fields);
        } else {
          printInfo.excludeFields = tat;
        }
        var tempO = this.utilService.applyArchiveArgs(printInfo, args, this);
        args = tempO.args;
        printInfo = tempO.printInfo;
        if (gridData.args != undefined && gridData.args != "") {
          if (args != undefined && args != "") {
            gridData.args = gridData.args + ',' + args;
          }

        } else {
          if (args != undefined && args != "") {
            gridData.args = args;
          }
        }
      }

      gridData.printInfo = printInfo;
      gridData.page_size = printInfo.page_size;
      // gridData.newPrint = printInfo.newPrint ? printInfo.newPrint : false;
      if (printInfo.amount != undefined) {
        gridData.amount = printInfo.amount;
      }
    } else {
      if (this.isDownloadOnly()) {
        this.loader.hideSpinner();
        return;//no API call is needed since only download of the data is allowed
      }
      /*************** NO COUNT IMPLEMENTATION *******************/
      var defaultNoCount = true;
      if (gridData["query_id"] != undefined && gridData["query_id"] == "GET_PAGE") {
        defaultNoCount = true;
      }
      this._currentData.dataGridConfig.noCount = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.noCount != undefined ? this._currentData.resouceDef.config.noCount : defaultNoCount;
      if (this._currentData.dataGridConfig.noCount != undefined && this._currentData.dataGridConfig.noCount) {
        var args = "noCount:1";
        if (gridData.args != undefined && gridData.args != "" && !gridData.args.includes("noCount")) {
          gridData.args = gridData.args + ',' + args;
        } else if (gridData.args != undefined && gridData.args != "" && gridData.args.includes("noCount")) {
          gridData.args = gridData.args;
        } else {
          gridData.args = args;
        }
      } else if (this._currentData.dataGridConfig.noCount != undefined && !this._currentData.dataGridConfig.noCount && gridData.args != undefined && gridData.args.includes("noCount")) {
        gridData.args = gridData.args.replace("noCount:1", "");
      }

      /*************** NO COUNT IMPLEMENTATION *******************/

      /*************** NO Rule IMPLEMENTATION *******************/
      if ((!this.ruleEngineService.config.resetFilter) && ((this.ruleEngineService != undefined && this.ruleEngineService.config != undefined && this.ruleEngineService.config.ruleInfo != undefined && this.ruleEngineService.config.ruleInfo) || (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData['noRule'] != undefined && this._currentData.gridData['noRule']))) {
        if (gridData.args != undefined && gridData.args) {
          gridData.args = gridData.args + ',' + 'noRule:true';
        }
        else {
          gridData.args = 'noRule:true';
        }
        gridData['noRule'] = true;
      }

      try {

        if (this._currentData.saveFilterKey != undefined && this.persistGrid()) {
          delete this._currentData.saveFilterKey;
          this.saveFilterObj({ gridData: gridData }, (responseConfig) => {
            var queryObj = {};
            queryObj[responseConfig["filterSaveKey"]] = responseConfig["filterKey"];

            var url = this.router.createUrlTree([], { relativeTo: this.route, queryParams: queryObj, queryParamsHandling: 'merge' }).toString()
            this.locationCommon.replaceState(url);

            //this.router.onSameUrlNavigation = 'ignore';
            this.router.navigate(['.'], { relativeTo: this.route, queryParams: queryObj, replaceUrl: true, queryParamsHandling: 'merge' });//maintain history so that user could go back (uncommenting because router params was not updating)
          });
        }
        //  else{
        //    this.resetFilterKey();
        //  }
      } catch (e) {
        console.log(e);
        this._currentData.resouceDef.resource
      }

    }

    this.applyArchivePoicy(gridData, false);
    if (this._currentData.resouceDef && this._currentData.resouceDef.config && this._currentData.resouceDef.config.encodeFilter && gridData.filter && gridData.filter != '') {
      gridData.filter = this.baseService.checkArgsandEncode(gridData.filter);
    }
    if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator) {
      this._currentData.decorator.bindGridExtended(gridData, resource, application, (val) => {
        gridData = val.gridData; resource = val.resource; application = val.application;
      });
    }
    if (this?._currentData?.dataGridConfig?.barcode_config?.performActionOnScan === true) {
      if(this?.ngZone){
        this?.ngZone?.runOutsideAngular(()=>{
          this.setupBarcodeListener(this?._currentData?.decorator?.barcodeKeydownListener);
        });
      }
    }
    //this will work for normal case
    if (!printInfo) {
      this.bindGridWithoutPrint(gridData, "", resource, application, callback);
    }
    //for print
    else if (printInfo) {
      this.bindGridWithPrint(gridData, "", resource, application, printInfo, callback);
    }
    else {
      //do nothing
    }
  }
  private __isComplexSearchFocusedOrDiaglogActive(): boolean {
    const activeElement = document.activeElement;
    if (!activeElement) {
      return false;
    }
    const activeElementId = activeElement.id;
    const activeElementClass = activeElement.className;

    // Check if any of the specified input fields have focus
    const isSearchInputFocused =
      activeElementId === 'search-menu-text' ||
      activeElementId === 'complex-search-input' ||
      activeElementId === 'search_value_input' ||
      activeElementId === 'search' ||
      activeElementClass.includes('form-control input-element-main-search') ||
      activeElementClass.includes('search form-control') ||
      document.getElementsByTagName('app-dialog').length > 0;

    console.log("isSearchInputFocused: ", isSearchInputFocused);

    return isSearchInputFocused;
  }
  setupBarcodeListener(listener: (event: KeyboardEvent) => void) {
    this.cleanBarcodeListener();

    if(!listener){
      return;
    }

    const handleKeydown = (event: KeyboardEvent) => {
      if(this.__isComplexSearchFocusedOrDiaglogActive()){
        console.log("Search is using, so skipping barcodeKeyDownListener method call.");
        return;
      }

      if(this?.ngZone){
        this?.ngZone?.run(()=>{
          listener.call(this, event);
        });
      }
    };

    document.addEventListener('keydown', handleKeydown);
    this.utilService.setBoundBarcodeListener(handleKeydown);
  }
  cleanBarcodeListener() {
    const listener = this.utilService.getBoundBarcodeListener();
    if (listener) {
        document.removeEventListener('keydown', listener);
        this.utilService.setBoundBarcodeListener(undefined);
    }
  }

  // For removing duplicate values from array
  concatExcludeFieldFn(existingVal, newVal) {
    return this.utilService.concatExcludeFieldFn(existingVal, newVal);
  }


  applyArchivePoicy(gridData, isSummary) {
    this.utilService.applyArchivePoicy(gridData, isSummary, this);
  }
  isDownloadOnly() {
    if (this._currentData != undefined && this._currentData.archiveConfig != undefined && this._currentData.archiveConfig.selected != undefined && this._currentData.archiveConfig.selected.download_only != undefined && this._currentData.archiveConfig.selected.download_only) {
      return true;
    }
    return false;
  }
  saveFilterObj(config, callback) {
    var filterSaveKey = "f__k";
    var gridData;
    var filterKey = this.baseService.generateID(5);
    var filterObj = { key: filterKey };
    var savedObj = this.getFilterLabel();

    if (savedObj && savedObj["key"] != undefined) {
      filterObj["key"] = savedObj["key"]; //we found already saved filter whose key is present in url bar
    }

    if (config["gridData"] != undefined) {
      gridData = config["gridData"];
      if (gridData['filter'] != undefined && gridData['filter'] && this._currentData.filterPrintInfo != undefined && this._currentData.filterPrintInfo) {

        if (gridData['filter'] != undefined) {
          filterObj["filter"] = gridData['filter'];
        }

        if (this._currentData.filterPrintInfo != undefined) {
          filterObj["filterLabel"] = this._currentData.filterPrintInfo;
        }

      }

      if (gridData && gridData["search_columns"] != undefined) {
        filterObj["search_columns"] = gridData["search_columns"];
      }

      if (gridData && gridData["search"] != undefined) {
        filterObj["search"] = gridData["search"];
      }
      if (gridData && gridData["searchLabel"] != undefined) {
        filterObj["searchLabel"] = gridData["searchLabel"];
      }

      if (gridData && gridData["searchColumns"] != undefined) {
        filterObj["searchColumns"] = gridData["searchColumns"];
      }
      if (gridData && gridData["noRule"] != undefined) {
        filterObj["noRule"] = gridData["noRule"];
      }
      if (gridData && gridData["filterName"] != undefined) {
        filterObj["filterName"] = gridData["filterName"];
      }
      if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
        //do nothing
      }
      else if (gridData && gridData["eq_search"] != undefined) {
        filterObj["eq_search"] = gridData["eq_search"];
      }

      this.storageService.setSessionStorageData(filterSaveKey + "_" + this._currentData.resouceDef.resource, filterObj, () => {
        callback({ filterSaveKey: filterSaveKey, filterKey: filterObj["key"] });
      });
    }

    return false;


  }


  bindGridWithoutPrint(gridData, val, resource, application, callback) {
    if (this._currentData.dataGridConfig?.aiSummary != undefined) {
      this._currentData.dataGridConfig.aiSummary.load = false;
      if (gridData["filter"] != undefined && gridData["filter"] != "") {
        this._currentData.dataGridConfig.aiSummary.filter = gridData["filter"]
      }
      if (gridData["args"] != undefined && gridData["args"] != "") {
        this._currentData.dataGridConfig.aiSummary.args = gridData["args"]
      }
    }
  //  const gridTiming =this._currentData.dataGridConfig.gridExecutionTiming ??={};
  //  gridTiming.apiStartTime = performance.now();
    if(this.commonServiceUi?.['visibleFields']?.length>0 && this.projectionEnabled){
      gridData["projectionKeys"] = this.commonServiceUi['visibleFields']
    }
    this.baseService.getData(gridData, "", resource, application).subscribe(
      (data: any) => {
        //if not print
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          this._currentData.dataList = [];
          if (callback)
            callback(false);
        } else {
          if(this._currentData.dataGridConfig?.aiSummary != undefined &&data.url != undefined && data.url){
            this._currentData.dataGridConfig.aiSummary["final_url"]  = data.url
          }
          
          // if (this._currentData.dataGridConfig.taggable) {
          //   this.mapTagsWithGrid(data, resource || this.baseService._resourceName, application || this.baseService.getAppName());
          // }
          // else {
          //this line for dynamic data manipulation
          // if(this._currentData.resouceDef.dynamic_key != undefined){
          //   data.resource.map(x=>x[this._currentData.resouceDef.dynamic_key])
          // }
        //  gridTiming.dbResponseTime = performance.now();
          if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.decorator.processDataList != undefined) {
            this._currentData.decorator.processDataList(this._currentData, data, (dataR) => {
              this._currentData.dataList = dataR;
              if (callback)
                callback(gridData);
            })
          } else {
            this._currentData.dataList = data;
            if (callback)
              callback(gridData);
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
        if (callback)
          callback(false);
      }
    );
  }


  checkDownload(gridData) {
    let str;
    if (gridData != undefined && gridData.printInfo != undefined && gridData.printInfo.action != undefined && (gridData.printInfo.actionType == 'downloadAll' || gridData.printInfo.actionType == 'downloadCSV') && this._currentData != undefined && this._currentData.dataList != undefined) { str = "/download" }
    else {
      if (gridData != undefined && gridData.printInfo != undefined && gridData.printInfo.action != undefined && gridData.printInfo.action == "print-async") {
        str = "/print-async";
      } else {
        str = "/print";
      }
    }
    return str;
  }

  bindGridWithPrint(gridData, val, resource, application, printInfo, callback) {
    gridData = this.baseService.encodeURIPrintGridData(gridData);
    let obj = {
      _currentResource: resource ? resource : this._currentData.resource,
      application: application,
      queryId: printInfo.overrideQueryId === true ? printInfo.query_id : gridData.query_id,
      args: gridData.args != undefined ? gridData.args : "",
      amount: gridData.amount != undefined ? btoa(JSON.stringify(gridData.amount)) : '',
      filter: gridData.filter != undefined ? gridData.filter : "",
      contentType: gridData.printInfo != undefined && gridData.printInfo.file_type != undefined ? gridData.printInfo.file_type : "",
      gridInfo: gridData.printInfo != undefined && gridData.printInfo.gridInfo != undefined ? btoa(JSON.stringify(gridData.printInfo.gridInfo)) : "",
      bannerInfo: gridData.printInfo != undefined && gridData.printInfo.bannerInfo != undefined ? btoa(JSON.stringify(gridData.printInfo.bannerInfo)) : "", bannerData: gridData.printInfo != undefined && gridData.printInfo.bannerData != undefined ? gridData.printInfo.bannerData : "", page_no: this._currentData.gridData.page_no, page_size: gridData.page_size, gridHeading: this.baseService._currentTitle != undefined ? this.baseService._currentTitle : "",
      search: gridData.search != undefined ? gridData.search : "",
      search_columns: gridData.searchColumns != undefined ? gridData.searchColumns : "",
      filterPrintInfo: gridData && gridData.printInfo != undefined && gridData.printInfo.filterPrintInfo != undefined && gridData.printInfo.filterPrintInfo ? btoa(JSON.stringify(gridData.printInfo.filterPrintInfo)) : false,
      facility_name: this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.facility_name != undefined && this._currentData.resouceDef.config.facility_name ? this._currentData.resouceDef.config.facility_name : false,
      account_name: this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.account_name != undefined && this._currentData.resouceDef.config.account_name ? this._currentData.resouceDef.config.account_name : false,
      secondary_uhid: gridData && gridData.printInfo && gridData.printInfo.secondaryUhidKey ? true : false,
      download_summary: (this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.download_summary != undefined) ? this._currentData.resouceDef.config.download_summary : false,
      excludeFields: (gridData.printInfo != undefined && gridData.printInfo.excludeFields != undefined) ? gridData.printInfo.excludeFields : false,
      print_all: this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.print_all != undefined && this._currentData.resouceDef.config.print_all ? this._currentData.resouceDef.config.print_all : false,
    };
    if (gridData && gridData.printInfo && gridData.printInfo.ehrViewKey) {
      obj['read_scope_level'] = 'account'
    }

    //adding projection keys to printObj
    try {
      if(this.commonServiceUi?.['visibleFields']?.length>0 && this.projectionEnabled){
        gridData["projectionKeys"] = this.commonServiceUi['visibleFields']
      } else if (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData.projectionKeys != undefined && this._currentData.gridData.projectionKeys) {
        obj['projectionKeys'] = this._currentData.gridData.projectionKeys.toString();
      }
      else if (gridData.printInfo != undefined && gridData.printInfo.actionType != undefined && ["downloadCSV", "download"].indexOf(printInfo.actionType) > -1) {
        let arr = this._currentData.resouceDef.list['projectionKeys'] != undefined && this._currentData.resouceDef.list['projectionKeys'] ? this._currentData.resouceDef.list['projectionKeys'] : [];
        obj['projectionKeys'] = this.baseService.getProjectionKeys(this._currentData.currentListFields, arr).toString();
        if (gridData.printInfo.type != undefined && gridData.printInfo.type == "print") {
          obj["type"] = gridData.printInfo.type
          if (gridData.printInfo.post_obj != undefined) {
            obj["post_obj"] = gridData.printInfo.post_obj
          }
        }

      }
    } catch (error) { }


    /*********ForBulk download */
    let str = this.checkDownload(gridData);
    let responseType = "blob";
    if (str == '/download') {
      responseType = "application/json";
    } else if ((str == '/print' || str == '/print-async') && gridData.printInfo.actionType != undefined && ["download"].indexOf(printInfo.actionType) > -1) {
      responseType = "application/text";
    }
    // action(_resource, action, application?, resource?, bpmn_action?, responseType?)
    let resource_ = resource != undefined && resource ? resource + str : this.baseService._resourceName + str;
    if (gridData != undefined && gridData.order_by != undefined && gridData.order_by) {
      obj['order_by'] = gridData.order_by;
    }
    if (gridData != undefined) { // This is condition for new printengine gridprint
      // obj['newPrint'] = gridData.newPrint;
      if (gridData.printInfo != undefined && gridData.printInfo.gridInfo != undefined) {
        if (gridData.printInfo.print_data == undefined)
          obj['template'] = "grid";
        else
          obj['template'] = gridData.printInfo.template
      }
    }
    if (obj.args != undefined && gridData.args.indexOf("chunk_download:true") > -1) {
      if (this._currentData?.resouceDef?.config?.downloadAll != undefined) {
        if (this._currentData?.resouceDef?.config?.downloadAll.interval != undefined) {
          obj.args = obj.args + ",download_interval:" + this._currentData?.resouceDef?.config?.downloadAll.interval
        }
        if (this._currentData?.resouceDef?.config?.downloadAll.interval_size != undefined) {
          obj.args = obj.args + ",download_interval_size:" + this._currentData?.resouceDef?.config?.downloadAll.interval_size
        }
      }
    }

    // _resource, action, application?, resource?, bpmn_action?, responseType?)
    this.baseService.action(obj, "", application, resource_, "", { responseType: responseType, printApplication: true }).subscribe(
      async (data: any) => {
        if (printInfo) {
          if (data.errCode != undefined && data.errCode == -9) {
            //do nothing
          } else if ((str == '/print' || str == '/print-async') && gridData.printInfo.actionType != undefined && ["download"].indexOf(printInfo.actionType) > -1) {
            var fileName = (obj.gridHeading != undefined) ? obj.gridHeading : this.baseService.titleService.getTitle();
            fileName += ".csv";
            printInfo["postObj"] = { ...obj };
            printInfo["resource"] = resource_;
            if (this._currentData.gridData != undefined && this._currentData.gridData.frontendSorting != undefined) {
              printInfo["frontendSorting"] = this._currentData.gridData.frontendSorting;
            }
            this.downloadService.formatData(data, printInfo, fileName);
          } else if (str === "/print-async" && data.type === "application/json") {
            // Inherited from line number 3523-3539 @24/04/2025
            try {
              var response = await data.text();
              response = JSON.parse(response);
              if (response.errCode == -1 && response.message != undefined) {
                this.alerts.error(response.message);
              }
              if (response.errCode == 0 && response.message != undefined) {
                this.alerts.success(response.message, "", true);
              }
              console.log(response);
            } catch (e) {
              this.alerts.error('API error');
            }
          } else { this.printService.handleFileReponse({ contentType: printInfo.file_type, key: this.baseService._currentTitle }, printInfo.action, data); }
        } else {
          //if not print
          if (data.errCode == -1) {
            this.alerts.error(data.message);
            this._currentData.dataList = [];
            if (callback)
              callback(false);
          } else {
            this._currentData.dataList = data;
            if (callback)
              callback(gridData);
          }
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
        if (callback)
          callback(false);
      }
    );
  }



  switchView(res) {
    var snapshot = this.activatedRoute.snapshot;
    var params = { ...snapshot.queryParams };
    var tab_key = 'layout';
    params[tab_key] = res;
    // this.router.navigate([], { queryParams: params });
    /******************COMMNETED BECAUAE IT was causting issue with filtter persisting on url *************/
    /*this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([], { queryParams: params });*/
    /******************COMMNETED BECAUAE IT was causting issue with filtter persisting on url *************/
    // console.log("Grid Table ", this._currentData.dataGridConfig);
    this._currentData.dataGridConfig = { ...this._currentData.dataGridConfig, ...this._currentData.gridData };
    this._currentData.dataGridConfig.limit = this._currentData.gridData.page_size;
    console.log("Grid Table ", this._currentData.dataGridConfig);
    if (res == 'table') {
      this._currentData.config.activeField = 'table';
      this._currentData.dataGridConfig.activeField = this._currentData.config.activeField;
      if (this._currentData.config.activeField) {
        this._currentData.showView = false;
        setTimeout(() => {
          this._currentData.showView = true;
        })
      }
      // this.bindGrid();
    }
    else if (res == 'tile') {
      this._currentData.config.activeField = 'tile';
      this._currentData.dataGridConfig.activeField = this._currentData.config.activeField;
      if (this._currentData.config.activeField) {
        this._currentData.showView = false;
        setTimeout(() => {
          this._currentData.showView = true;
        })
      }
      // this.bindGrid();
    }
    //Again initialising quick filter
    if (this._currentData && this._currentData.quick_filters)
      this._currentData.currentFilterListFormFields.quick_filters = this._currentData.quick_filters;
    this._currentData.preferenceData["layout__"] = res;
    this._currentData.preferenceData = JSON.parse(JSON.stringify(this._currentData.preferenceData));

    /********* Below code is for setting filterAr (quick filter) *********/
    try {
      if (this._currentData.preferenceData != undefined && this._currentData.preferenceData && this._currentData.dataGridConfig != undefined && this._currentData.dataGridConfig.filterAr) {
        let notQuickFilter = this._currentData.dataGridConfig.filterAr.filter(x => x.type != 'quick');
        if (notQuickFilter != undefined && notQuickFilter && notQuickFilter.length != undefined && notQuickFilter.length > 0) {
          this._currentData.preferenceData['filter__'] = notQuickFilter;
        }
      }
    } catch (error) {
      console.log("Error  in settting Filter Ar : " + error);
    }

    this.savePreference();
  }

  onFormTab(event: any) {

  }

  onSaveFinished(event: any) {
    if (this.saveFinished.observers.length > 0) {
      this.saveFinished.next(event);
    } else {
      /******** DEOCRATOR IMPLEMENTATION *******/
      if (this._currentData.decorator != undefined && this._currentData.decorator) {
        this._currentData.decorator.beforeSubmitRequest(event);
      }
      if (this._currentData.decorator != undefined && this._currentData.decorator) {
        var submitInsideDecorator = this._currentData.decorator.submitInsideDecorator(event, (result) => {
          if (result) {
            this.afterSubmitActions(event, result);
          }
        });
        if (submitInsideDecorator) {
          return;
        }
      }
      /******** DEOCRATOR IMPLEMENTATION *******/
      switch (event.currentBtnVal.action) {
        case 'redirect':
          let url = event.currentBtnVal.redirectUrl;
          this.router.navigateByUrl(url);
          break;
        case 'draft':
          //To do for draft action
          event.result['isDraft'] = true;
          this.saveData(event);
          break;
        case 'doNothing':
          //do Nothing 
          break;
        default:
          this.saveData(event);
          break;
      }
    }

  }

  saveData(event, callback = null, skipTemplateCheck = false) {
    this.loader.showSpinner();
    if (!skipTemplateCheck && this?._currentData?.configForm?.resource_config?.templateInterceptor) {
      this.checkTemplates(event, this._currentData.configForm.resource_config);
      return;
    }
    var relayId;
    if (this._currentData.currentAction == 'MODIFY') {
      event.result.id = this._currentData.currentData.id;
      if (event.result != undefined && event.result.id) {
        relayId = JSON.parse(JSON.stringify(event.result.id));
      }
    } else if (this._currentData.currentAction == 'ADD') {
      if (event.result != undefined && event.result.id) {
        relayId = JSON.parse(JSON.stringify(event.result.id));
      }
      delete event.result.id;
      delete event.result.g_creation_time;
    }
    var resource = '';
    var application = '';
    var action = '';
    if (this._currentData.currentFormFields.APIresource && this._currentData.currentFormFields.APIresource != undefined && this._currentData.currentFormFields.APIresource.datasource != undefined) {
      console.log("API Resource", this._currentData.currentFormFields.APIresource)
      resource = this._currentData.currentFormFields.APIresource.datasource['resource'];
      application = this._currentData.currentFormFields.APIresource.datasource['application'];
      if (this._currentData.currentFormFields.APIresource.datasource.action != undefined) {
        action = this._currentData.currentFormFields.APIresource.datasource.action;
      } else {
        action = this._currentData.currentAction;
      }
    } else {
      resource = this._currentData.resouceDef.resource;
      application = '';
      action = this._currentData.currentAction;
    }
    if (event && event.currentBtnVal && event.currentBtnVal.datasource != undefined) {
      if (event.currentBtnVal.datasource.action != undefined)
        action = event.currentBtnVal.datasource.action;
      if (event.currentBtnVal.datasource.resource != undefined && event.currentBtnVal.datasource.resource)
        resource = event.currentBtnVal.datasource.resource;
      if (event.currentBtnVal.datasource.application != undefined && event.currentBtnVal.datasource.application)
        application = event.currentBtnVal.datasource.application;
    }
    event.result = { ...event.result, ...this._currentData.foreignKeyData };
    if (this._currentData.currentFormFields.append_object != undefined && this._currentData.currentFormFields.append_object) {
      event.result = { ...event.result, ...this._currentData.currentFormFields.append_object };
    }
    let projection_keys;
    if (this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.form != undefined && this._currentData.resouceDef.form.postProjectionKeys != undefined) {
      projection_keys = this._currentData.resouceDef.form.postProjectionKeys;
    }

    // (_resource, action, application ?, resource ?, bpmn_action ?, responseType ?, args ?, obj ?)

    //passing undefined to handle parameters for projections
    this.baseService.action(event.result, action, application, resource, undefined, undefined, undefined, { postProjectionKeys: projection_keys }).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          if (this._currentData.decorator != undefined && this._currentData.decorator) {
            this._currentData.decorator.afterSubmitReqError(event, data, this.formComponenet);
          }
          if (callback) {
            callback(false);
          }
        } else {
          if (this._currentData != undefined && this._currentData.currentFormFields != undefined && this._currentData.currentFormFields.APIresource != undefined && this._currentData.currentFormFields.APIresource.relay_call != undefined && this._currentData.currentFormFields.APIresource.relay_call) {
            this.relayCall(event, relayId, () => {
              this.afterSubmitActions(event, data);
            });
          }
          else {
            this.afterSubmitActions(event, data);
          }
        }
        this.loader.hideSpinner();
        if (callback != null) {
          data['resourceName'] = resource;
          callback(data);
        }
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
        if (callback) {
          callback(false);
        }
      }
    )
  }

  relayCall(event, relayId, callBack?) {
    {
      let action_ = this._currentData.currentFormFields.APIresource.relay_call.action != undefined ? this._currentData.currentFormFields.APIresource.relay_call.action : "";
      let application_ = this._currentData.currentFormFields.APIresource.relay_call.apllication_ != undefined ? this._currentData.currentFormFields.APIresource.relay_call.apllication_ : "";
      let resource_ = this._currentData.currentFormFields.APIresource.relay_call.resource != undefined ? this._currentData.currentFormFields.APIresource.relay_call.resource : "";
      //adding id
      let obj = { id: relayId };
      this.baseService.action(obj, action_, application_, resource_).subscribe((data) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
        }
        else {
          callBack();
        }
      });
    }
  }

  // callDecorator(event, data) {

  // }

  afterSubmitActions(event, data) {
    this.communicationService.emitChange({ completed: true });
    if (this._currentData.currentAction == 'ADD') {
      this.alerts.success("Added Successfully");
    } else {
      this.alerts.success("Updated Successfully");
    }
    var redirectLogic = true;
    /******** DEOCRATOR IMPLEMENTATION *******/
    if (this._currentData.decorator != undefined && this._currentData.decorator) {
      redirectLogic = this._currentData.decorator.afterSubmitReqSuccess(event, data, this.formComponenet);
    }
    /******** DEOCRATOR IMPLEMENTATION *******/

    if (redirectLogic) {
      this.formComponenet.resetFormClick();
      if (event.currentBtnVal.action != undefined && ['print', 'download', 'view_file'].indexOf(event.currentBtnVal.action) > -1) {
        this.handleFile(event.currentBtnVal, { data: data.resource[0] }, (response) => {
          if (!response) {
            this.alerts.error("Print Error");
          }
          if (this._layout == 'tab') {
            if (this.suppressListNavigation) {
              this.listNavigationSkipped.emit(data);
            } else {
              this.router.navigate(['.'], { relativeTo: this.route, queryParams: { "tab": this.route.snapshot.queryParams.tab_0, "returnUrl": this.route.snapshot.queryParams.returnUrl, "key": this.route.snapshot.queryParams.key != undefined ? this.route.snapshot.queryParams.key : this.arg_key, "banner": this.route.snapshot.queryParams.banner } });
            }
          } else {
            this.listResource(event.currentBtnVal, data);
          }
        });
      } else {
        if (this._layout == 'tab') {
          if (this.suppressListNavigation) {
            this.listNavigationSkipped.emit(data);
          } else {
            this.router.navigate(['.'], { relativeTo: this.route, queryParams: { "tab": this.route.snapshot.queryParams.tab_0, "returnUrl": this.route.snapshot.queryParams.returnUrl, "key": this.route.snapshot.queryParams.key != undefined ? this.route.snapshot.queryParams.key : this.arg_key, "banner": this.route.snapshot.queryParams.banner } });
          }
        } else {
          this.listResource(event.currentBtnVal, data);
        }
      }
    }
  }

  deleteResource(id) {
    this.loader.showSpinner();
    var application = '';
    var resource = '';
    if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
      application = this._currentData.APIresource.application;
      if (this._currentData.APIresource.resource != undefined) {
        resource = this._currentData.APIresource.resource;
      }
    }

    this.baseService.action({ id: id }, 'DELETE', application, resource).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.loader.hideSpinner();
          this.alerts.error(data.message);
        } else {
          this.alerts.success("Deleted Successfully");
          this.bindGridFn();
        }
      }, error => {
        console.log(error);
        this.loader.hideSpinner();
        this.alerts.error('API error');
      }
    )
  }

  addResource(link) {
    let url = "";
    if (link != undefined) {
      if (link.redirect == undefined) {
        let current = (this._currentData.view == undefined) ? this._currentData.resource : this._currentData.view;
        url = '/' + this.appService.getApplication() + '/' + current + '/add';
        if (link.get_key != undefined) {
          this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: this.route.snapshot.queryParams.key != undefined ? this.route.snapshot.queryParams.key : this.arg_key } });
        } else {
          this.router.navigate([url], { queryParams: { returnUrl: this.router.url } });
        }
      } else if (link.redirect.redirectLink && link.redirect.redirectLink != undefined) {
        if (link.redirect.redirectLink.includes("!!!getterKey!!!")) {
          // let getterKey = eval(link.redirect.getterKey);
          link.redirect.redirectLink = link.redirect.redirectLink.replace('!!!getterKey!!!', "");
          this.router.navigate([link.redirect.redirectLink], { queryParams: { returnUrl: this.router.url, key: eval(link.redirect.getterKey) } });
        } else {
          this.router.navigate([link.redirect.redirectLink], { queryParams: { returnUrl: this.router.url } });
        }

      } else {
        let app = link.redirect.application == undefined ? this.appService.getApplication() : link.redirect.application;
        let resource = link.redirect.resource == undefined ? this._currentData.resource : link.redirect.resource;
        url = '/' + app + '/' + resource + '/add';
        this.router.navigate([url], { queryParams: { returnUrl: this.router.url } });
      }
    } else {
      if (this._currentData.currentForeignId != undefined) {
        if (this.route.snapshot.data.add_foreign != undefined && this.route.snapshot.data.add_foreign) {
          url = '/' + this.appService.getApplication() + '/' + this.route.snapshot.data.resource + '/add' + '/' + this._currentData.currentForeignId;
        } else {
          url = '/' + this.appService.getApplication() + '/' + this.route.snapshot.data.parent_resource + '/' + this._currentData.currentForeignId + '/' + this.route.snapshot.data.resource + '/ADD';
        }

      } else {
        let current = (this._currentData.view == undefined) ? this._currentData.resource : this._currentData.view;
        url = '/' + this.appService.getApplication() + '/' + current + '/add';
      }
      this.router.navigate([url], { queryParams: { returnUrl: this.router.url } });
    }
  }

  ngOnDestroy() {
    if (this.modal != undefined) {
      this.modal._hideBackdrop();
      this.modal._hideModal(1);
      this.modal.hide(1);
    }
    if (this.dialogRef)
    this.dialogRef.close();

    this.hasSubscription.unsubscribe();
    this.routeParamsSubscription.unsubscribe();

    // ADD THIS — clears dynamically created components
    if (this.customComponent) {
      this.customComponent.clear();
    }
    if (this.parentComponent) {
      this.parentComponent.clear();
    }

    if(this?.ngZone){
      this?.ngZone?.runOutsideAngular(()=>{
        this.cleanBarcodeListener();
      });
    }
}

  listResource(currentBtnVal?, data?) {
    if (this.suppressListNavigation) {
      this.listNavigationSkipped.emit(data);
      return;
    }
    if (currentBtnVal) {
      if (currentBtnVal.redirectUrl) {
        currentBtnVal.redirectUrl = (currentBtnVal.redirectUrl.indexOf('!!!') > -1) ? (currentBtnVal.redirect_key != undefined) ? currentBtnVal.redirectUrl.replace('!!!' + currentBtnVal.redirect_key + '!!!', ((data.resource[0][currentBtnVal.redirect_key] != undefined) ? data.resource[0][currentBtnVal.redirect_key] : '')) : currentBtnVal.redirectUrl : currentBtnVal.redirectUrl;
        this.router.navigate([currentBtnVal.redirectUrl]);
      }
      else {
        if (this.route.snapshot.queryParams.hasOwnProperty('returnUrl') && this.route.snapshot.queryParams.hasOwnProperty('tab')) {
          //window.location.reload();
        } else if (this.route.snapshot.queryParams.hasOwnProperty('returnUrl')) {
          // change here by saurav deep by navigate is not working prperly
          this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
        } else {
          let current = (this._currentData.view == undefined) ? this._currentData.resource : this._currentData.view;
          const url = '/' + this.appService.getApplication() + '/' + current + '/list';
          this.router.navigate([url]);
        }
      }
    }
    else {
      if (this.route.snapshot.queryParams.hasOwnProperty('returnUrl')) {
        console.log("this.route.snapshot.queryParams.returnUrl,", this.route.snapshot.queryParams.returnUrl);
        this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl); // change here by saurav deep by navigate is not working prperly
      } else {
        let current = (this._currentData.view == undefined) ? this._currentData.resource : this._currentData.view;
        const url = '/' + this.appService.getApplication() + '/' + current + '/list';
        this.router.navigate([url]);
      }
    }
    /**********Focusing on the top of the screen */
    try {
      window.scrollTo(0, 0);
    } catch (error) {

    }
    /** Focus end */

    /** Decorator for backNavigationClick event access */
    if (!this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.decorator.backNavigationClick) {
      this._currentData.decorator.backNavigationClick();
    }
    /** Decorator for backNavigationClick event access */

  }

  getByID() {
    this.loader.showSpinner();
    // Collect paginated composite-array fields
    if (this?._currentData?.resouceDef?.form?.blocks) {
      this.collectPaginatedFieldsFromForm(this._currentData.resouceDef.form.blocks).then((paginatedFields: Set<string>) => {
        // Remove nested fields
        [...paginatedFields].map(field => {
          if (field.indexOf('.') > -1) {
            paginatedFields.delete(field);
          }
        })
        console.log("Paginated Fields ", paginatedFields);
        // Call API with paginated fields
        this.getByIDWithParams(this._currentData.currentId, undefined, undefined, [...paginatedFields]);
      })
      .catch((error) => {
        console.log("error in collecting paginated fields: ", error);
        this.getByIDWithParams(this._currentData.currentId, undefined, undefined, undefined);
      });
    }
  }

  private getByIDWithParams(id: string, resource?:string, application?: string, excludeFields?: string[]) {
    this.baseService.getById(id, resource, application, excludeFields).subscribe(
      (data: any) => {
        if (data.errCode == -1) {
          this.alerts.error(data.message);
        } else {
          console.log("Current Data ", this._currentData);
          this._currentData.currentData = data;
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      }
    )
  }

  private getByQueryIDWithParams(apiObj, excludeFields?: string[]) {
    this.baseService.get(apiObj.query_id, apiObj.args, apiObj.resource, apiObj.application, apiObj.filter != undefined && apiObj.filter ? apiObj.filter : "", undefined, undefined, excludeFields).subscribe((data: any) => {
      if (data.errCode == -1) {
        this.alerts.error(data.message);
      } else {
        if (data.resource != undefined && data.resource.length > 0) {
          this._currentData.currentData = data.resource[0];
        } else {
          this._currentData.currentData = [];
        }
      }
      this.loader.hideSpinner();
    }, (error) => {
      console.log(error);
      this.alerts.error('API error');
      this.loader.hideSpinner();
    })
  }

  getByQueryID(apiObj?) {
    this.loader.showSpinner();
    if (apiObj == undefined) {
      var apiObj: any = {};
      apiObj.resource = this._currentData.currentFormFields.datasource.resource != undefined ? this._currentData.currentFormFields.datasource.resource : this._currentData.resource;
      apiObj.application = this._currentData.currentFormFields.datasource.application != undefined ? this._currentData.currentFormFields.datasource.application : this.appService.getApplication();

      apiObj.key = this._currentData.currentFormFields.datasource.key != undefined ? this._currentData.currentFormFields.datasource.key : 'id';
      apiObj.query_id = this._currentData.currentFormFields.datasource.query_id != undefined ? this._currentData.currentFormFields.datasource.query_id : "GET_BY_ID";

      let data = {};
      try {
        data = JSON.parse(sessionStorage.getItem('currentData'));
      } catch (error) { }

      apiObj.args = this._currentData.currentFormFields.datasource.args != undefined ? this.baseService.buildDyanamicStr(this._currentData.currentFormFields.datasource.args, { data: data }) : 'dummy:dummy';
      // Filter Functionality Added
      apiObj.filter = this._currentData.currentFormFields.datasource.filter != undefined ? this.baseService.buildDyanamicStr(this._currentData.currentFormFields.datasource.filter, { data: data }) : 'dummy:dummy';

      apiObj.args = apiObj.key + ":" + this._currentData.currentId + ',' + apiObj.args;
      if (this.route?.snapshot?.queryParams?.gridArgs) {
        apiObj.args += "," + this.route.snapshot.queryParams.gridArgs
      }
      if (this._currentData != undefined && this._currentData.currentFormFields != undefined && this._currentData.currentFormFields.datasource != undefined && this._currentData.currentFormFields.datasource.filter != undefined && this._currentData.currentFormFields.datasource.filter) {
        // Added backward compatibility for apiObj.key - 'if we don't want to pass id in filter then we need to pass key as false in datasource or it'll take key as id in filter (as it was taking earlier)' 
        if (apiObj.key) {
          apiObj.filter = apiObj.key + ":" + this._currentData.currentId + ',' + apiObj.filter;
        }
      }
    }
    // Collect paginated composite-array fields
    if (this?._currentData?.resouceDef?.form?.blocks) {
      this.collectPaginatedFieldsFromForm(this._currentData.resouceDef.form.blocks).then((paginatedFields: Set<string>) => {
        // Remove nested fields
        [...paginatedFields].map(field => {
          if (field.indexOf('.') > -1) {
            paginatedFields.delete(field);
          }
        })
        console.log("Paginated Fields ", paginatedFields);
        // Call API with paginated fields
        this.getByQueryIDWithParams(apiObj, [...paginatedFields]);
      })
      .catch((error) => {
        console.log("error in collecting paginated fields: ", error);
        this.getByQueryIDWithParams(apiObj);
      });
    } else {
      this.getByQueryIDWithParams(apiObj)
    }
  }

  addFilterDownload() {
    // this.baseService.getResourceDef(this._currentData.currentResource, (resourceDef) => {
    if (this._currentData.resouceDef && this._currentData.resouceDef.config && this._currentData.resouceDef.config.care_type && this._currentData.resouceDef.config.care_type.header) {
      this._currentData.gridData.filter = (this._currentData.gridData.filter) ? (this._currentData.gridData.filter + "," + this.appService.getAppData().AUTO_FILTERS[0]["filter_key"] + ":" + this.appService.getDynamicFunctions("getCurrentCareType")) : (this.appService.getAppData().AUTO_FILTERS[0]["filter_key"] + ":" + this.appService.getDynamicFunctions("getCurrentCareType"));
    }
    // })
  }

  setProjectionOnBulk(action_obj) {
    if (action_obj.projectionkeys != undefined && action_obj.projectionkeys && this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.dynamicProjection != undefined && this._currentData.resouceDef.config.dynamicProjection) {
      if (this._currentData.archiveConfig != undefined && this._currentData.archiveConfig.selected != undefined && this._currentData.archiveConfig.selected.select_all != undefined && this._currentData.archiveConfig.selected.select_all) {
        this._currentData.gridData.projectionKeys = [];
      } else {
        this._currentData.gridData.projectionKeys = action_obj.projectionkeys;
      }
    }
  }

  actionClicked(action_dt) {
    console.log("Action data ", action_dt);
    if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator) {
      this._currentData.decorator.capabilityClick(action_dt, (val) => {
        if (val && val.type == 'bind-grid') {
          if (val.removefilter) {
            this._currentData.gridData.filter = this._currentData.gridData.filter.replace(',' + val.filter, '');
          } else if (val.filter)
            this._currentData.gridData.filter += ',' + val.filter;
          this.bindGridFn();
        }
      });
    }
  }

  onBulkActionClicked(action_obj) {
    if (action_obj.action != undefined && action_obj.action == "form_grid_archival") {
      this._currentData["archiveConfig"]["selected"] = action_obj.event["archiveConfig"];
      this._currentData["archiveConfig"]["applied"] = true;
      this._currentData.dataGridConfig = {};
      this._currentData.gridData.page_no = 0;
      this._currentData.resouceDef = action_obj.resourceDef;
      this._currentData.archiveConfig.list = action_obj.archive_list
      this._currentData.currentListFields = this._currentData.resouceDef.list.fields;
      if (this._currentData.resouceDef.list.hasOwnProperty('APIresource') && this._currentData.resouceDef.list.APIresource.datasource != undefined) {
        this._currentData.APIresource = this._currentData.resouceDef.list.APIresource.datasource;

      }
      return;
    }

    this.setProjectionOnBulk(action_obj);

    if (typeof action_obj.action == "string" && ['print', 'print-async', 'download', 'view_file'].indexOf(action_obj.action) > -1) {
      if (this.appService.getUniversalConfig('multi_care_type')) {
        this.addFilterDownload() // this line is added to add filter in resource if present in resource
      }
      if (action_obj.gridData != undefined) {
        this._currentData.gridData = action_obj.gridData;//for formwithgrid pagination syncing
      }
      var menuObj = { actionType: JSON.parse(JSON.stringify(action_obj)).items, data: {} };

      if (action_obj.items != undefined && action_obj.items.file_data != undefined) {
        try {
          if (action_obj.items.file_data.chunk_download != undefined) {
            menuObj.actionType.file_data.chunk_download = true;
          } else {
            delete menuObj.actionType.file_data.chunk_download;
          }
          if (action_obj.items.file_data.chunk_size != undefined) {
            menuObj.actionType.file_data.chunk_size = action_obj.items.file_data.chunk_size;
          } else {
            delete menuObj.actionType.file_data.chunk_size;
          }
        } catch (e) {
          console.error(e)
        }

      }
      if (menuObj.actionType.file_data.actionType && ["downloadAll", "downloadCSV"].indexOf(menuObj.actionType.file_data.actionType) > -1) {

        if (menuObj.actionType.file_data.type != undefined && menuObj.actionType.file_data.page_size != undefined && menuObj.actionType.file_data.type == "print") {
          menuObj.actionType.file_data.page_size = menuObj.actionType.file_data.page_size;
          var postObj: any = {}
          postObj.gridHeading = (this.baseService._currentTitle != undefined) ? this.baseService._currentTitle : "List";
          postObj.resource = (this._currentData.resource != undefined) ? this._currentData.resource + "/print" : false;
          menuObj.actionType.file_data.post_obj = JSON.stringify(postObj);

        } else {
          menuObj.actionType.file_data.page_size = 0;
        }
      } else if (menuObj.actionType.file_data.actionType) {
        menuObj.actionType.file_data.page_size = this._currentData.gridData.page_size;
        // if(this._currentData.gridData.page_size == 0){
        //   this._currentData.gridData.page_size = 10;
        // }
      } else {
        menuObj.actionType.file_data.page_size = this._currentData.gridData.page_size;
      }
      if (menuObj.actionType.file_data.gridInfo != undefined) {
        menuObj.actionType.file_data.gridHeading = this.baseService._currentTitle;
        if (menuObj != undefined && menuObj.actionType != undefined && menuObj.actionType.action == "print" && menuObj.actionType.file_data != undefined && menuObj.actionType.file_data.print_data != undefined && menuObj.actionType.file_data.print_data == "grid" && action_obj.$event != undefined && action_obj.$event.ctrlKey != undefined && action_obj.$event.ctrlKey) {
          menuObj.actionType.file_data.action = "print-async";
          menuObj.actionType.action = "print-async";
        }
        // If condition for Grid All Async Print
        if (this._currentData && this._currentData.resouceDef && this._currentData.resouceDef.config && this._currentData.resouceDef.config.print_all && menuObj != undefined && menuObj.actionType != undefined && menuObj.actionType.action == "print" && menuObj.actionType.isGrid && action_obj.items != undefined && action_obj.items.file_data != undefined && action_obj.items.file_data.page_size) {
          menuObj.actionType.file_data.page_size = action_obj.items.file_data.page_size;
        }
        if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
          if (this._currentData.APIresource == undefined) {
            this._currentData.APIresource = this._currentData.resouceDef.list.APIresource.datasource;
          }
          this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id, menuObj.actionType.file_data);
        } else {
          this.bindGrid(false, false, false, false, menuObj.actionType.file_data);
        }
      } else {
        var gridData = JSON.parse(JSON.stringify(this._currentData.gridData));//making a clone

        if (this.route.snapshot.data.foreign_id != undefined && this.route.snapshot.data.foreign_id && this._currentData.currentForeignId) {  // this line is olny work for View_Details three dot click
          if (gridData.hasOwnProperty('filter')) {
            gridData['filter'] += this.route.snapshot.data.foreign_id + ':' + this._currentData.currentForeignId;
          } else {
            gridData['filter'] = this.route.snapshot.data.foreign_id + ':' + this._currentData.currentForeignId;
          }
        }

        if (gridData["filter"] != "") {
          if (menuObj.actionType.file_data.filter != undefined && menuObj.actionType.file_data.filter != "") {
            menuObj.actionType.file_data.filter = menuObj.actionType.file_data.filter + "," + gridData["filter"];
          } else {
            menuObj.actionType.file_data.filter = gridData["filter"];
          }
        }
        this.handleFile(menuObj.actionType, menuObj);
      }

    } else if (typeof action_obj.action == "object" && action_obj.action.action != undefined && ['print', 'download', 'view_file'].indexOf(action_obj.action.action) > -1) {
      if (action_obj.action.file_data != undefined && action_obj.action.file_data.cumulativeInfo != undefined && action_obj.items != undefined && action_obj.items.length > 0) {
        if (this.appService.getUniversalConfig('multi_care_type')) {
          this.addFilterDownload() // this line is added to add filter in resource if present in resource
        }
        let cumulativeInfoObject = JSON.parse(JSON.stringify(action_obj.action.file_data.cumulativeInfo));
        let cumulativeInfo = this.baseService.createCumilativeObj(action_obj);
        action_obj.action.file_data.cumulativeInfo = btoa(JSON.stringify(cumulativeInfo));
        if (action_obj.action.file_data.filterPrintInfo != undefined && action_obj.action.file_data.filterPrintInfo) {
          action_obj.action.file_data.filterPrintInfo = btoa(JSON.stringify(action_obj.action.file_data.filterPrintInfo));
        }
        this.handleFile(action_obj.action, { data: {} });
      }
    } else {
      //TODO: implementation
    }
  }

  limitChanged(event, resource?, application?, type?) {
    this._currentData.gridData.page_no = 0;
    this.updatePageInUrl(this._currentData.gridData.page_no);
    this._currentData.gridData.page_size = event.target.value;
    this._currentData.gridData['limit_change'] = true;
    if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
      this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
    } else {
      this.bindGrid(resource, application, type);
    }
  }
  setBarcodeParams(event) {
    if (event.barcode != undefined && event.barcode && this._currentData.resouceDef.list.hasOwnProperty('barcode_config') && this._currentData.resouceDef.list.barcode_config.hasOwnProperty('reset_filter')) {
      let filter = JSON.parse(JSON.stringify(this._currentData.gridData.filter));
      let validFilter = this.baseService.checkargs(filter);
      this._currentData.gridData.filter = this.baseService.removeKeys(validFilter, this._currentData.resouceDef.list.barcode_config.reset_filter);
    }
    else {
      //do nothing
    }

  }
  filterChange(event, resource?, application?, type?) {
    this._currentData.gridData.page_no = 0;
    this.updatePageInUrl(this._currentData.gridData.page_no);
    var args = "noCount:1";
    if (this._currentData.resouceDef.config == undefined) {
      this._currentData.resouceDef.config = {};
    }
    this._currentData.resouceDef.config.noCount = true;

    if (this._currentData.gridData.args != undefined && this._currentData.gridData.args != "" && !this._currentData.gridData.args.includes("noCount")) {
      this._currentData.gridData.args = this._currentData.gridData.args + ',' + args;
    } else if (this._currentData.gridData.args != undefined && this._currentData.gridData.args != "" && this._currentData.gridData.args.includes("noCount")) {
      this._currentData.gridData.args = this._currentData.gridData.args;
    } else {
      this._currentData.gridData.args = args;
    }
    if (this._currentData.gridData.order_by)
      delete this._currentData.gridData.order_by;
    setTimeout(() => { // route params was not updating in above function so setTimeout was needed
      if (typeof event == 'object') {
        this._currentData.gridData.search_columns = [event.key];
        this._currentData.gridData.searchColumns = event.key;
        this._currentData.gridData.search = event.value;
        this._currentData.gridData.searchLabel = event.label == undefined ? "Search" : event.label;
        if (event.proxy_key != undefined && event.proxy_key) {
          this.storageService.setData('proxy_key' + this._currentData.resource, JSON.stringify(event.proxy_key), () => { });
        }
        try {
          if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true && event != undefined && event.key != undefined && event.key != 'telecom' && !event?.searchObj?.eq_search_mandatory) {

            if (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData.eq_search != undefined) {
              delete this._currentData.gridData.eq_search;
            }
            
          }
          else {

            if (event != undefined && event.key != undefined && event.key == 'telecom' && event.value != undefined && event.value.length != undefined && event.value.length <= 5) {
              this.alerts.error("f.l.IMN");
              return false;
            }

            if (event != undefined && event.searchObj != undefined && event.searchObj.eq_search != undefined) {
              this._currentData.gridData.eq_search = 'y';
            }
            else if (event != undefined && event.key != undefined && event.key == 'telecom') { 
              this._currentData.gridData.eq_search = 'y';
            }
            else if (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData.eq_search != undefined) {
              delete this._currentData.gridData.eq_search;
            }
          }


        } catch (error) {

        }

        this.setBarcodeParams(event);
      } else {
        this._currentData.gridData.search = event;
        if (event == "") {
          delete this._currentData.dataGridConfig.f__search;
          delete this._currentData.dataGridConfig.f__search_columns;
          delete this._currentData.dataGridConfig.f__searchColumns;
          delete this._currentData.dataGridConfig.f__searchLabel;
          this.getOrderBy();
        }
      }

      this._currentData.saveFilterKey = true;

      if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
        this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
      } else {
        this.bindGrid(resource, application, type);
      }
    });
  }

  updatePageInUrl(pageNo, force = false) {
    if (this.persistGrid() || force) {
      this._currentData.dataGridConfig.page_no = this._currentData.gridData.page_no;
      var snapshot = this.activatedRoute.snapshot;
      var params = { ...snapshot.queryParams };
      params["p__no"] = pageNo;

      var url = this.router.createUrlTree([], { relativeTo: this.route, queryParams: params, queryParamsHandling: '' }).toString()
      this.locationCommon.replaceState(url);

      //this.router.onSameUrlNavigation = 'ignore';
      this.router.navigate(['.'], { relativeTo: this.route, queryParams: params, replaceUrl: true, queryParamsHandling: '' });//maintain history so that user could go back  //(uncommenting because router params was not updating)
    }
  }

  persistGrid() {
    if (this._currentData.origArhiveConfig != undefined) {
      return false;
    }
    if (this._currentData && this._currentData["archiveConfig"] != undefined && this._currentData["archiveConfig"]["applied"] != undefined && this._currentData["archiveConfig"]["applied"]) {
      return false;
    }
    return (this.constructor.name.toLowerCase() == "uienginecomponent");
  }
  pageChanges(event, resource?, application?, type?) {
    this._currentData.gridData.currentBtnVal = '';
    this._currentData.gridData.page_no = event - 1;
    this.updatePageInUrl(this._currentData.gridData.page_no);
    if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
      this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
    } else {
      this.bindGrid(resource, application, type);
    }
  }

  sortChanges(event, resource?, application?, type?) {
    if (event != undefined && event.frontendSorting != undefined) {
      if (event.clear != undefined && event.clear) {
        delete this._currentData.gridData.frontendSorting;
      } else {
        this._currentData.gridData.frontendSorting = event;
      }

    } else {
      if (event && event.form != undefined)
        this._currentData.gridData.filter = event.form
      this._currentData.gridData.page_no = 0;
      this.updatePageInUrl(this._currentData.gridData.page_no);
      if (event == undefined)
        this._currentData.gridData.order_by = '';
      else
        this._currentData.gridData.order_by = event.key + ' ' + ((event.value == 'desc') ? event.value : '');
      if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
        this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
      } else {
        this.bindGrid(resource, application, type);
      }
    }
  }
  printBarCode() {

  }
  setdataForDublicasy(menuObj) {
    try {
      this.storageService.setTabId(JSON.stringify(menuObj.data), menuObj.actionType.storeInfoForDublicacy.unique_keys);
    } catch (error) { }
  }

  //this works on click of capabilty
  buttonAction(menuObj) {
    //for ristricting dublicasy
    // if (menuObj != undefined && menuObj.actionType != undefined && menuObj.actionType.storeInfoForDublicacy != undefined) {
    //   let res = this.setdataForDublicasy(menuObj);
    // }
    if (this._currentData.filterList && this._currentData.filterList.length > 0) {
      this._currentData.dataGridConfig.hideSearchBox = false;
      this._currentData.filterList = [];
    }
    //initiatiing capability decorartor
    if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.capabilityDecorater) {
      this._currentData.decorator.capabilityClick(menuObj, (val) => {
        if (val) {
          this.performAction(menuObj);
        }
      });
    }
    else {
      if (this._currentData.gridData && this._currentData.gridData.currentBtnVal != undefined && this._currentData.gridData.currentBtnVal) {
        this._currentData.gridData.currentBtnVal = '';
      }
      this.performAction(menuObj);
    }
  }


  //capability click methods are included in this function
  performAction(menuObj) {
    this._currentData.customClick = true;
    console.log("menuObj ", menuObj);
    if (menuObj != undefined && menuObj.actionType != undefined && menuObj.actionType.action == "print" && menuObj.$event != undefined && menuObj.$event.ctrlKey != undefined && menuObj.$event.ctrlKey) {
      menuObj.actionType.action = "print-async";
    }
    try {
      if (menuObj && menuObj.data != undefined && menuObj.data['care_type'] == undefined && this.appService.getUniversalConfig('multi_care_type')) {
        menuObj.data['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType")
        menuObj.data['care_type_name'] = this.appService.getDynamicFunctions("getCurrentCareTypeName")
      }
    } catch (error) {
      console.log("error");
    }
    if (menuObj.actionType.required_rowData) {
      sessionStorage.setItem('currentData', JSON.stringify(menuObj.data))
    }
    if (menuObj.actionType.type == 'print_barCode') {
      this.printBarCode();
    }
    switch (menuObj.actionType.action) {
      case "delete":
        this.deleteResourceConfirm(menuObj.data, menuObj.data[menuObj.actionType.key]);
        break;
      case "custom":
        if (menuObj.actionType.hasOwnProperty('setValue')) {
          if (menuObj.actionType.resource != undefined && menuObj.actionType.resource != "" && menuObj.actionType.resource != null && menuObj.actionType.resource) {
            var resource = menuObj.actionType.resource;
            // localStorage.setItem("CurrentResource", resource);
            this.storageService.setCurrentResource(resource);
          }
          this.storageService.setDataToAutofillForm(menuObj.actionType.setValue, menuObj.data, () => {
          });
        } else { }
        //if (!menuObj.actionType.key)
        this.customRoute(menuObj.actionType, menuObj.data, { dhsIdLists: menuObj.itemIdLists });
        // else
        //   this.customRoute(menuObj.actionType, menuObj.data[menuObj.actionType.key]);
        break;
      case "confirm":
        this.confirmBoxResource(menuObj.data, menuObj.actionType);
        break;
      case "direct_request":
        this.preventActionCapability(menuObj.data, menuObj.actionType);
        break;
      case "validate_confirm":
        this.confirmBoxResource(menuObj.data, menuObj.actionType);
        break;

      case "api_request":
        this.apiRequest(menuObj.data, menuObj.actionType);
        break;
      case "remote_confirm":
        if (menuObj.actionType.hasOwnProperty('setValue')) {
          if (menuObj.actionType.resource != undefined && menuObj.actionType.resource != "" && menuObj.actionType.resource != null && menuObj.actionType.resource) {
            var resource = menuObj.actionType.resource;
            // localStorage.setItem("CurrentResource", resource);
            this.storageService.setCurrentResource(resource);
          }
          this.storageService.setDataToAutofillForm(menuObj.actionType.setValue, menuObj.data, () => {
          });
        }
        if (!menuObj.actionType.key)
          this.confirmRemote(menuObj.data, menuObj.actionType);
        else
          this.confirmRemote(menuObj.data[menuObj.actionType.key], menuObj.actionType);
        break;
      case "print":
        if (menuObj.actionType != undefined && menuObj.actionType.print_barcode != undefined && menuObj.actionType.print_barcode && this.appService.getAccountConfig().print_barcode != undefined && this.appService.getAccountConfig().print_barcode) {
          menuObj.data['fromUiEngine'] = true;
          this.utilService.printLabel(menuObj.data);
          break;
        }
        else {
          // for cumulativeInfo
          if (menuObj.actionType.file_data != undefined && menuObj.actionType.file_data.cumulativeInfo != undefined && menuObj.data != undefined && menuObj.data.length > 0) {
            let action_obj = {
              action: menuObj.actionType,
              items: menuObj.data,
            }
            let cumulativeInfoObject = JSON.parse(JSON.stringify(action_obj.action.file_data.cumulativeInfo));
            let cumulativeInfo = this.baseService.createCumilativeObj(action_obj);
            action_obj.action.file_data.cumulativeInfo = btoa(JSON.stringify(cumulativeInfo));
          }
          if (menuObj?.actionType?.file_data && menuObj.actionType.file_data.checkPrintStatus) {
            this.getPrintStatus(menuObj.data, menuObj);
            break;
          }
        }
      case "view_file":
      case "download":
        this.downloadBifercation(menuObj);
        break;
      case "bulk_download":
        this.bulkDownload(menuObj);
        break;
      case "print-async":
        // for cumulativeInfo
        if (menuObj.actionType.file_data != undefined && menuObj.actionType.file_data.cumulativeInfo != undefined && menuObj.data != undefined && menuObj.data.length > 0) {
          let action_obj = {
            action: menuObj.actionType,
            items: menuObj.data,
          }
          let cumulativeInfoObject = JSON.parse(JSON.stringify(action_obj.action.file_data.cumulativeInfo));
          let cumulativeInfo = this.baseService.createCumilativeObj(action_obj);
          action_obj.action.file_data.cumulativeInfo = btoa(JSON.stringify(cumulativeInfo));
        }
        if (menuObj != undefined && menuObj.actionType != undefined && menuObj.actionType.file_data != undefined && menuObj.actionType.file_data.print_data != undefined && menuObj.actionType.file_data.print_data == "grid") {
          this.onBulkActionClicked({ action: menuObj.actionType.action, items: menuObj.actionType });
        } else {
          this.downloadBifercation(menuObj);
        }
        break;
      case "modify":
        if (menuObj.actionType.hasOwnProperty('setValue')) {
          this.storageService.setDataToAutofillForm(menuObj.actionType.setValue, menuObj.data, () => {
            this.goToRoute(menuObj.actionType, menuObj.data[menuObj.actionType.key], menuObj.data);
          });
        } else {
          this.goToRoute(menuObj.actionType, menuObj.data[menuObj.actionType.key], menuObj.data)
        }
        break;
      case "view_details":
        this.goToRoute(menuObj.actionType, menuObj.data[menuObj.actionType.key], menuObj.data);
        break;
      case "copy":
        this.copyResourceFn(menuObj);
        break;
      case "refresh":
        this.setProjectionOnBulk(menuObj);
        this.bindGridFn();
        break;
      case "savedata":
        break;
      case "video_popup":
        break;
      case "social":
        this.socialCalling(menuObj.data, menuObj.actionType);
        break;
      case "table_view":
        this.switchView(menuObj.actionType.action_name);
        break;
      case "card_view":
        this.switchView(menuObj.actionType.action_name);
        break;
      case "open_popup":
        this.openCustomComponent(menuObj.data, menuObj.actionType);
        break;
      case "QrCode":
        this.generateQRCode(menuObj.data, menuObj.actionType);
        break;
      default:
        this.goToRoute(menuObj.actionType, menuObj.data[menuObj.actionType.key], menuObj.data);
        break;
    }
  }
  getPrintStatus(data, menuObj) {
    this.isPrintReady(data, (cb) => {
      if (cb)
        this.printReady(data, menuObj);
      else
        this.printNotReady(data, menuObj);
    })
  }
  private printReady(response, menuObj) {
    this.downloadBifercation(menuObj);
  }
  private printNotReady(response, menuObj) {
    let msg = "Billing is in progress ..."
    this.baseService.modalService.confirmCustomBtn("Print Bill", msg, ModalSize.Sm, { cancel: "Cancel", ok: "Retry" }).subscribe(
      (result: boolean) => {
        if (result) {
          this.isPrintReady(response, (cb) => {
            if (cb) {
              this.printReady(response, menuObj)
            } else {
              this.printNotReady(response, menuObj);
              this.alerts.info(msg);
            }
          })
        } else {
          //this.goBack();
        }
      });
  }
  isPrintReady(response, callBack) {
    if (response.admissionId && response.uhId) {
      this.loader.showSpinner();
      let args = `admissionId:${response.admissionId},uhId:${response.uhId},service_type_code:pharmacy`;
      this.baseService.get("GET_BILLING_SUMMARY_STATUS", args, "billing_summary", "billing").subscribe(data => {
        if (data.errCode == 0 && data.resource.length > 0) {
          this.loader.hideSpinner();
          if (data.resource[0].status == 'Completed')
            callBack(true);
          else
            callBack(false);
        } else {
          this.loader.hideSpinner();
          callBack(false);
        }
      }, (err) => {
        this.loader.hideSpinner();
        console.log("error is in isPrintReady function")
      });
    } else {
      this.alerts.error("Admission id or Uhid not found");
      this.loader.hideSpinner();
    }
  }
  preventActionCapability(data, action) {
    this.loader.showSpinner();
    if (action.datasource.data != undefined) {
      var res = action.datasource.data[0];
      for (let i = 0; i < Object.keys(res).length; i++) {
        data[Object.keys(res)[i]] = res[Object.keys(res)[i]];
      }
      this.confirmResource(data, action);
    } else {
      this.confirmResource(data, action);
    }
  }

  generateQRCode(data, action) {
    let lbl = "QR Code Generator"; let obj = { "data": data, "action": action };
    this.smartModalService.open(QrCodeGeneratorComponent, obj, lbl, ModalSize.Sm).subscribe(
      response => {
        // this.redirectToOtherPage(response.result.resource[0], 'popup');
      }, err => { }
    );
  }

  openCustomComponent(data, action) {
    let popObj = {
      data: { "menuData": data, "action": action },
      title: '',
      size: DialogModalSize.Lg
    };
    if (this['parentForm'] && this['parentForm'].formService && this['parentForm'].formService.form && this['parentForm'].formService.form.controls) {
      popObj['parentFormControls'] = this['parentForm'].formService.form.controls
    }
    var dgRef = this.dialogService.openWithSelector(this.baseService, action.selector, popObj);
  }

  bulkDownload(obj) {
    this.baseService.getFileByUrl(obj.data.url, false).subscribe(res => {
      this.printService.handleFileReponse({
        contentType: "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        KeyWithExt: obj.data.file_name
      }, "download", res)
    })
  }

  projectionKeysConfig(){ 
    this.projectionEnabled = this.appService.getAccountConfigValue("projection_enabled") == 'true' ? true : false; 
  }

  downloadBifercation(menuObj) {
    try {
      //0 is hardcoded as data is expected at that level 
      if (menuObj != undefined && menuObj.actionType != undefined && menuObj.actionType.s3_print != undefined && menuObj.actionType.s3_print.key && menuObj.data != undefined && menuObj.data[menuObj.actionType.s3_print.key] != undefined
        && (menuObj.data[menuObj.actionType.s3_print.key].filter(data => data.print_type == menuObj.actionType.s3_print.print_type))) {
        //let imageurl = "/dms/api/v1/" + menuObj.data[menuObj.actionType.s3_print.key][0].document_type + "/image-response-entity?path=" + menuObj.data[menuObj.actionType.s3_print.key][0].document_url;
        this.baseService.get('GET_CONFIG', "module_code:printengine,config_code:s3_print", 'facility_config_mapping', "facility-management").subscribe(data => {
          if (data != undefined && data.resource != undefined && data.resource[0].config_value == 'yes') {
            // this.baseService.getFileByUrl(imageurl, false).subscribe(res => {
            //   if (res) {
            //     this.printService.handleFileReponse({ contentType: 'pdf', key: menuObj.actionType.key }, menuObj.actionType.action, res);
            //   }
            //   this.loader.hideSpinner();
            // })

            // Added print details to send paramenters in resources and call s3 from backend (printengine)
            var print_details = menuObj.data[menuObj.actionType.s3_print.key].filter(data => data.print_type == menuObj.actionType.s3_print.print_type);
            if (print_details != undefined && print_details.length > 0) {
              menuObj.actionType.file_data["print_details"] = print_details;
            }
          }
          // else {
          //   this.handleFile(menuObj.actionType, menuObj);
          // }
          console.log("print_details", print_details);
          this.handleFile(menuObj.actionType, menuObj);
        })

      } else if (menuObj != undefined && menuObj.actionType != undefined && menuObj.actionType.s3_print_check != undefined) {
        if (menuObj.actionType.s3_print_check.document_datasource) {
          let datasource = menuObj.actionType.s3_print_check.document_datasource;
          let args;
          let filter;
          if (datasource.args)
            args = this.baseService.buildDyanamicStr(datasource.args, { data: menuObj.data });
          if (datasource.filter)
            filter = this.baseService.buildDyanamicStr(datasource.filter, { data: menuObj.data });
          let gridData = {
            args: args,
            filter: filter
          }
          this.baseService.getData(gridData, "", datasource.resource, datasource.application, datasource.queryId).subscribe(
            (data: any) => {
              if (data.errCode == 0 && data.resource && data.resource.length > 0) {
                if (data.resource[0][datasource.getterKey] == undefined || data.resource[0][datasource.getterKey] == '') {
                  this.handleFile(menuObj.actionType, menuObj);
                } else
                  this.getFile(menuObj.actionType.s3_print_check.key, data.resource[0][datasource.getterKey], menuObj);
              } else {
                this.handleFile(menuObj.actionType, menuObj);
              }
            });
        } else if (menuObj.actionType.s3_print_check.document_key) {
          this.getFile(menuObj.actionType.s3_print_check.key, menuObj.data[menuObj.actionType.s3_print_check.document_key], menuObj);
        }
      } else {
        this.handleFile(menuObj.actionType, menuObj);
      }
    } catch (error) {
      this.handleFile(menuObj.actionType, menuObj);
    }

  }

  getFile(key, url, menuObj) {
    let imageurl = "/dms/api/v1/" + key + "/image-response-entity?path=" + url;
    let args = menuObj?.actionType?.file_data?.args ?? menuObj?.actionType?.s3_print_check?.document_datasource?.args;
    this.baseService.getFileByUrl(imageurl, false).subscribe(res => {
      if (res) {
        let type = 'pdf';
        const docType: string = menuObj?.data?.doc_type;
        if (docType) {
          type = docType.split('.')[1];
        }
        let documentName: string = menuObj?.actionType?.documentName;
        if (documentName) {
          if (documentName.includes("!!!")) {
            documentName = this.baseService.buildDyanamicStr(documentName, { data: menuObj.data });
          }
        }
        this.printService.handleFileReponse({ contentType: type, args: this.baseService.buildDyanamicStr(args, { data: menuObj.data }), key: documentName ? documentName : menuObj.actionType.key }, menuObj.actionType.action, res);
      } else {
        this.handleFile(menuObj.actionType, menuObj);
      }
      this.loader.hideSpinner();
    })
  }

  socialCalling(key, action) {
    if (action.hasOwnProperty("type") && action.type == "call")
      window.location.href = `tel://${key[action.key]}`
    else if (action.hasOwnProperty("type") && action.type == "email")
      window.location.href = `mailto:${key[action.key]}`
    else if (action.hasOwnProperty("type") && action.type == "whatsApp")
      this.appService.checkNativeApp() ? window.location.href = `whatsapp://send/?phone=${key[action.key]}` : window.location.href = `https://api.whatsapp.com/send?phone=${key[action.key]}`;
    else if (action.hasOwnProperty("type") && action.type == "social_media")
      window.location.href = `${key[action.key]}`
  }

  copyResourceFn(obj) {
    if (obj.actionType != undefined && obj.data != undefined) {
      if (obj.actionType?.copy_config?.fetch_from_db && obj.data[obj.actionType.key] != undefined) {
        this.loader.showSpinner();
        const id = obj.data[obj.actionType.key ?? 'id'];
        const resource = obj?.actionType?.copy_config?.resource || this._currentData.resource;
        const application = obj?.actionType?.copy_config?.application || this.appService.getApplication();
        this.baseService.getById(id, resource, application).subscribe((data: any) => {
          this.loader.hideSpinner();
          if (data && data[obj.actionType.key ?? 'id'] === id) {
            this.router.navigate(['../add'], { relativeTo: this.route, state: { form_data: data } });
          } else {
            this.alerts.error('Error while fetching data to copy');
          }
        });
        return;
      }
      if (obj.actionType.exclude_fields != undefined && obj.actionType.exclude_fields.length) {
        for (let field of obj.actionType.exclude_fields) {
          this.baseService.unsetComposite(obj.data, field);
        }
      }
      this.router.navigate(['../add'], { relativeTo: this.route, state: { form_data: obj.data } });
    }
  }

  handleFile(action, obj, callback = null) {
    this.loader.stophideSpinner(true);
    if (action.file_data != undefined) {
      var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
      this.loader.showSpinner();
      var fileObj = JSON.parse(JSON.stringify(action.file_data));
      fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
      fileObj.amount = fileObj.amount != undefined ? fileObj.amount : '';
      fileObj.resource = fileObj.resource != undefined ? this.baseService.buildDyanamicStr(fileObj.resource, obj) : this._currentData.resource;
      fileObj.application = fileObj.application != undefined ? this.baseService.buildDyanamicStr(fileObj.application, obj) : this.appService.getApplication();
      fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
      fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
      fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;
      fileObj.print_doc_details = (fileObj.print_details != undefined && fileObj.print_details != undefined && fileObj.print_details.length > 0) ? fileObj.print_details : undefined;
      if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && this._currentData.bannerJson != undefined && this._currentData.bannerJson.key != undefined) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : this._currentData.bannerJson.key.facility_id);
      } else if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && ((this.appService.getOrganization().org_id != undefined && this.appService.getOrganization().org_id) || (sessionStorage.getItem('facility_id') != undefined && sessionStorage.getItem('facility_id')))) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
      }
      fileObj.args = this.baseService.appendEhrFacilityIdArg(fileObj.args, obj);
      if (action.action == "print-async") {
        fileObj.action = action.action;
      }
      this.baseService.handleFile(fileObj, async (fileData) => {
        this.loader.stophideSpinner(false);
        if (fileData) {
          if (fileData.type == "application/json") {
            try {
              var response = await fileData.text();
              response = JSON.parse(response);
              // if (response.printErrorMessage && response.printErrorMessage != undefined) {
              //   response["printErrorMessage"] = this.utilService.extractTextContent(response.printErrorMessage);
              // }
              if (response.errCode == -1 && response.message != undefined) {
                this.alerts.error(response.message);
              }
              if (fileObj.action && fileObj.action == "print-async" && response.errCode == 0 && response.message != undefined) {
                this.alerts.success(response.message, "", true);
              }
              console.log(response);
            } catch (e) {
              this.alerts.error('API error');
            }
          } else {
            fileObj.key = key;
            this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
            if (callback && this.appService.checkNativeApp()) {
              callback(true)
            }
          }
        } else {
          this.alerts.error('server error');
          if (callback) {
            callback(false);
          }

        }
        this.loader.hideSpinner();
      }, (error) => {
        this.loader.hideSpinner();
        this.alerts.error('API error');
        if (callback) {
          callback(false);
        }
      });
    } else {
      this.loader.stophideSpinner(false);
      console.error("Please provide File Data");
      if (callback) {
        callback(false);
      }
    }
  }

  // handleFileReponse(fileObj, action, fileData, callback = null) {
  //   var fileName = "";
  //   var fileResponse: any = "";
  //   if (fileObj.contentType != 'byte_array') {
  //     fileName = fileObj.key + '.' + fileObj.contentType;
  //     fileObj.contentType = "application/" + fileObj.contentType;//TODO (we have to get from mapping)
  //     fileResponse = fileData
  //   } else {

  //     fileName = (fileData.documentName != undefined) ? fileData.documentName : fileObj.key;
  //     fileObj.contentType = (fileData.documentContentType != undefined) ? fileData.documentContentType : fileObj.contentType;
  //     if (fileData.inputStream != undefined && fileData.inputStream.length > 0) {
  //       var fileData = fileData.inputStream;
  //       fileResponse = new Uint8Array(fileData.length);
  //       for (let i = 0; i < fileResponse.length; i++) {
  //         fileResponse[i] = fileData[i];
  //       }
  //     } else {
  //       this.alerts.error('File Data not found');
  //       this.loader.hideSpinner();
  //       if (callback) {
  //         callback(false);
  //       }
  //       return;
  //     }
  //   }
  //   switch (action) {
  //     case "download":
  //       this.baseService.downloadFile(fileResponse, fileObj.contentType, fileName, callback);
  //       break;
  //     case "print":
  //       this.baseService.printFile(fileResponse, fileObj.contentType, callback);
  //       break;
  //     case "view_file":
  //       this.baseService.viewFile(fileResponse, fileObj.contentType, callback);
  //       break;

  //     default:
  //       break;
  //   }
  // }

  customRoute(action, key, dhsData?) {
    //this will work as new capability and row click
    const customGridData = { ...this._currentData.gridData };
    if (action != undefined && action?.projection_keys != undefined && action?.projection_keys === false) {
      delete customGridData.projectionKeys;
    }
    if (action.route_path != undefined && action.route_path) {
      //here key is the data of the row
      this.baseService.redirectToOtherPage(action.route_path, key, customGridData, dhsData);
    }
    else {
      //console.log("Key ", action, key);
      var app = '';
      if (action.hasOwnProperty('application')) {
        app = action.application;
      } else {
        app = this.appService.getApplication();
      }
      var keyForUrl = '';
      if (action.hasOwnProperty('get_key')) {
        keyForUrl = this.route.snapshot.queryParams.key != undefined ? this.route.snapshot.queryParams.key : this.arg_key;
      } else {
        if (action.set_key != undefined && action.set_key != '') {
          keyForUrl = key[action.set_key];
        } else {
          keyForUrl = key.id ? key.id : key;//change by saurav deep for getting key
        }
      }
      let queryParams = { key: keyForUrl };
      if (this._currentData?.dataGridConfig?.aiSummary?.args && this._currentData?.resouceDef?.config?.gridArgs) {
        queryParams['gridArgs'] = this._currentData.dataGridConfig.aiSummary.args
      }
      if (action.hasOwnProperty('query_params')) {
        let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: key });
        queryParams = { ...queryParams, ...{ query_params } }
      }
      if (action.hasOwnProperty('queryParams')) {
        let banner = { banner: JSON.stringify(action.queryParams) }
        queryParams = { ...queryParams, ...banner, ...{ returnUrl: this.router.url } }
      } else {
        let returnUrl = { returnUrl: this.router.url };
        queryParams = { ...queryParams, ...returnUrl }
      }
      // if needed to set gridData (datasource) in route on basis of saveGridData flag
      if (action.saveGridData != undefined && action.saveGridData && this._currentData.gridData != undefined && this._currentData.gridData && dhsData) {
        queryParams['saveGridData'] = action.saveGridData;
        queryParams = { ...queryParams, ...customGridData };
        sessionStorage.setItem('data_grid_ids', JSON.stringify(dhsData));
      }

      //If extra params has to be passed
      if (action.addExtraParams) {
        queryParams = { ...queryParams, ...action.addExtraParams };
      }
      console.log("query Params is ", queryParams);
      let url = '';
      if (action.hasOwnProperty('redirect') && action.redirect.action != undefined) {
        if (action.redirect.action == 'modify' || action.redirect.action == 'view') {
          url = '/' + app + '/' + action.resource + '/' + key.id + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        } else if (action.redirect.action == 'list') {
          url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        } else {
          url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
          if (action.hasOwnProperty('queryParams')) {
            this.router.navigate([url], { queryParams: queryParams });
          } else {
            this.router.navigate([url], { queryParams: queryParams });
          }
        }
      } else if (action.hasOwnProperty('redirectLink')) {
        action.redirectLink = action.redirectLink.indexOf('!!!') != -1 ? this.baseService.buildDyanamicStr(action.redirectLink, { data: key }) : action.redirectLink;
        url = '/' + app + '/' + action.redirectLink;
        if (action.hasOwnProperty('queryParams')) {
          this.router.navigate([url], {
            queryParams: queryParams
          });
        } else {
          this.router.navigate([url], { queryParams: queryParams });
        }
      } else {
        if (action.dependent != undefined && action.dependent) {
          if (localStorage.getItem('filterValueInForm') == null) {
            alert("Select filter first");
          }
          else {
            let a = action.key ? key[action.key] : keyForUrl;
            url = '/' + app + '/' + keyForUrl + '/' + action.resource + '/' + (action.type ? action.type : '');
            this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: a } });
          }
        }
        else {
          let c = action.key ? key[action.key] : keyForUrl;
          url = '/' + app + '/' + encodeURIComponent(c) + '/' + action.resource + '/' + (action.type ? action.type : '');
          if (action.hasOwnProperty('queryParams') || action.hasOwnProperty('query_params')) {
            let b = action.key ? key[action.key] : keyForUrl;
            let extra_params = {};
            // if needed to set gridData (datasource) in route on basis of saveGridData flag
            if (action.saveGridData != undefined && action.saveGridData && this._currentData.gridData != undefined && this._currentData.gridData) {
              extra_params['saveGridData'] = action.saveGridData;
              extra_params = { ...queryParams, ...customGridData };
            }
            if (action.hasOwnProperty('query_params')) {
              let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: key });
              this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: b, data: JSON.stringify(action.queryParams), query_params: query_params, ...extra_params } });
            } else {
              this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: b, data: JSON.stringify(action.queryParams), ...extra_params } });
            }
          } else if (action.hasOwnProperty('new_tab')) {
            //saurav deep for opening video on pop up

            var teleService = this.baseService.getTeleService();
            if (teleService != undefined) {
              //key_to_send, key_to_show needs to be removed
              url = '/' + action['action_name'] + '/' + action['application']
              teleService.initCallData(this.getValue(key, action, "key_to_send"), this.getValue(key, action, "key_to_show"), this.getValue(key, action, "channel_id"), this.getValue(key, action, "order_id"), action, key, () => {
                this.bindGridFn();
              });
            }
          } else
            this.router.navigate([url], { queryParams: queryParams });
        }
      }
    }

  }

  getValue(item, hasJson, key: any) {
    if (hasJson[key].split("=>")[0].replace(/\s+/g, ' ').trim() == "(item)") {
      return eval(hasJson[key])(item)
    } else {
      return item[hasJson[key]]
    }
  }

  goToRoute(action, key, data?) {
    var keyForUrl = '';
    if (action.hasOwnProperty('get_key')) {
      keyForUrl = this.route.snapshot.queryParams.key != undefined ? this.route.snapshot.queryParams.key : this.arg_key;
    } else {
      keyForUrl = key;
    }
    let route = (this._currentData.view == undefined) ? this._currentData.resource : this._currentData.view;
    if (this._currentData.currentForeignId != undefined) {
      if (this.route.snapshot.data.add_foreign != undefined && this.route.snapshot.data.add_foreign) {
        url = '/' + this.appService.getApplication() + '/' + this.route.snapshot.data.resource + '/' + key + '/' + action.action + '/' + this._currentData.currentForeignId;
      } else {
        url = '/' + this.appService.getApplication() + '/' + this.route.snapshot.data.parent_resource + '/' + this._currentData.currentForeignId + '/' + this.route.snapshot.data.resource + '/' + key + '/' + action.action;
      }

    } else {
      var url = '/' + this.appService.getApplication() + '/' + route + '/' + key + '/' + action.action;
    }

    let queryParams = { key: keyForUrl };
    if (action.hasOwnProperty('query_params')) {
      let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: data });
      queryParams = { ...queryParams, ...{ query_params } }
    }
    if (action.hasOwnProperty('queryParams')) {
      let banner = { banner: JSON.stringify(action.queryParams) }
      queryParams = { ...queryParams, ...banner, ...{ returnUrl: this.router.url } }
    } else {
      let returnUrl = { returnUrl: this.router.url };
      queryParams = { ...queryParams, ...returnUrl }
    }
    if (this._currentData?.dataGridConfig?.aiSummary?.args && this._currentData?.resouceDef?.config?.gridArgs) {
      queryParams['gridArgs'] = this._currentData.dataGridConfig.aiSummary.args
    }
    if (action.hasOwnProperty('queryParams')) {
      this.router.navigate([url], { queryParams: queryParams });
    } else if (action.action == "view_details") {
      url = '/' + this.appService.getApplication() + '/' + this._currentData.resource + '/' + key + '/' + action.resource;
      this.router.navigate([url], { queryParams: queryParams });
    } else {
      this.router.navigate([url], { queryParams: queryParams });
    }
  }

  deleteResourceConfirm(data, key) {
    let name: string = "";
    if (data.name != undefined) {
      name = data.name;
    } else {
      name = "";
    }
    const dialogRef = this.modalService.confirm('DELETE', 'Are you sure you want to delete ' + name + '?', ModalSize.Sm);
    dialogRef.subscribe(result => {
      if (result) {
        this.deleteResource(key);
      }
    },
      () => { });
  }

  apiRequest(menudata, action) {
    if (action.datasource != undefined) {
      var apiObj: any = {};
      var datasource = JSON.parse(JSON.stringify(action.datasource));
      apiObj.resource = datasource.resource != undefined ? datasource.resource : this._currentData.resource;
      apiObj.query_id = datasource.query_id != undefined ? datasource.query_id : '';
      apiObj.application = datasource.application != undefined ? datasource.application : this.appService.getApplication();
      apiObj.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: menudata }) : '';
      apiObj.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: menudata }) : '';

      if (action.target == "_blank") {
        var url = this.baseService.getUrlByDataSource(apiObj);
        window.open(url, '_blank');
      } else {
        this.loader.showSpinner();
        this.baseService.getByDataSource(apiObj).subscribe(
          (data: any) => {
            if (data.errCode == -1) {
              this.alerts.error(data.message);
            }
            this.loader.hideSpinner();
          }, error => {
            console.log(error);
            this.alerts.error('API error');
            this.loader.hideSpinner();
          }
        )
      }

    } else {
      console.error("please define datasource");
    }

  }
  confirmRemote(menudata, action, type?) {
    if (action.datasource != undefined && action.expression != undefined) {
      var apiObj: any = {};
      var datasource = JSON.parse(JSON.stringify(action.datasource));
      apiObj.resource = datasource.resource != undefined ? datasource.resource : this._currentData.resource;
      apiObj.query_id = datasource.query_id != undefined ? datasource.query_id : 'GET_BY_ID';
      apiObj.application = datasource.application != undefined ? datasource.application : this.appService.getApplication();
      apiObj.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: menudata }) : '';
      apiObj.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: menudata }) : '';
      this.loader.showSpinner();
      this.baseService.getByDataSource(apiObj).subscribe(
        (data: any) => {
          if (data.errCode == -1) {
            this.alerts.error(data.message);
          } else {
            if (action && action.required_datasource_data)
              sessionStorage.setItem('DatasourceData', JSON.stringify(data.resource[0]));
            if (data.resource != undefined && data.resource.length > 0) {
              var item = data.resource[0];
              console.log(item);
              if (eval(action.expression)) {
                if (type != undefined && type == 'addButton') {
                  this.checkingConditions(menudata);
                } else {
                  if (action.config_check)
                    this.confirmBoxResource(menudata, action);
                  else
                    this.customRoute(action, menudata);
                }
              } else {
                //added condition for dynamic alert
                if (action.msg_key && action.msg_key.includes('.')) {
                  const err_message = action.msg_key.split('.').reduce((obj, key) => obj?.[key] ?? '', item);
                  this.alerts.error(err_message);
                } else if (action.msg_key && item[action.msg_key] != undefined && item[action.msg_key] != '') {
                  this.alerts.error(item[action.msg_key]);
                } else {
                  this.alerts.error(action.err_message || 'error');
                }
              }
            } else {
              if (action?.route === "void"){
                this.loader.hideSpinner();
                return; 
              }else{
                this.alerts.error(action?.err_message || "error");
              }
            }
          }
          this.loader.hideSpinner();
        }, error => {
          console.log(error);
          this.alerts.error('API error');
          this.loader.hideSpinner();
        }
      )
    } else {
      console.error("please define datasource");
    }

  }
  confirmBoxResource(data, action) {
    if (this.dialogRef)
      this.dialogRef.close();
    if (action && action.capability_datasource) {
      this.loader.showSpinner();
      //for custom capability datasource
      var apiObj: any = {};
      var datasource = JSON.parse(JSON.stringify(action.capability_datasource));
      apiObj.resource = datasource.resource != undefined ? datasource.resource : this._currentData.resource;
      apiObj.query_id = datasource.query_id != undefined ? datasource.query_id : 'GET_BY_ID';
      apiObj.application = datasource.application != undefined ? datasource.application : this.appService.getApplication();
      apiObj.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: data }) : '';
      apiObj.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: data }) : '';
      this.loader.showSpinner();
      this.baseService.getByDataSource(apiObj).subscribe(
        (res: any) => {
          if (res.errCode == -1) {
            this.alerts.error(res.message);
            this.loader.hideSpinner();
          } else {
            if (res.resource != undefined && res.resource.length > 0) {
              var item = res.resource[0];
              console.log(item);
              if (eval(action.expression))
                this.configCheckData(data, action);
              else
                this.openConfirmBox(data, action);
            }
          }
          this.loader.hideSpinner();
        }, error => {
          console.log(error);
          this.alerts.error('API error');
          this.loader.hideSpinner();
        }
      )
    } else
      this.configCheckData(data, action);
  }

  configCheckData(datat, action) {
    if (action.config_check) {
      this.baseService.get(action.config_check.query_id, action.config_check.args, action.config_check.resource, action.config_check.application).subscribe(data => {
        if (data.errCode == 0 && data.resource.length > 0) {
          if (data.resource[0].status == "active" && data.resource[0].config_value != undefined && data.resource[0].config_value != "" && data.resource[0].config_value.toLowerCase() == "yes") {
            this.loader.hideSpinner();
            this.alerts.error(action.config_check.message);
          } else {
            if (action.redirectLink) {
              this.customRoute(action, datat);
            } else
              this.openConfirmBox(datat, action);
          }
        }
      });
    } else {
      this.openConfirmBox(datat, action);
    }
  }

  checkTemplates(event, action) {
    try {
      this.loader.showSpinner();
      let datasource = action.templateInterceptor?.datasource ?? ''
      let config = action.templateInterceptor?.config ?? false
      let result = action.templateInterceptor.result_key != undefined ? event.result[action.templateInterceptor.result_key] : event.result;
      result['next_stage'] = action.templateInterceptor.next_stage;
      result['application_name'] = this.appService.getApplication()
      result['currentAction'] = datasource.customAction ?? this._currentData?.currentAction?.toLowerCase()
      if (this._currentData.currentData != undefined && this._currentData.currentData != undefined && this._currentData.currentData.patient_gender_id != undefined && this._currentData.currentData.patientType != undefined) {
        result['gender'] = this._currentData.currentData.patient_gender_id;
        result['patientType'] = this._currentData.currentData.patientType;
      }
      if (event?.id) {
        result['patient_id'] = this._currentData.currentData.id
      }
      if (result != undefined && !result.care_type) {
        try {
          result['care_type'] = this.appService.getDynamicFunctions("getCurrentCareType");
        } catch (error) { }
      }
      let args = this.baseService.buildDyanamicStr(datasource.args, { data: result });
      if (datasource.appendArgs != undefined && datasource.appendArgs) {
          args = args + "," + this.manupulateArgs([result], datasource.appendArgs);
      }
      this.baseService.get(datasource.query_id, args, datasource.resource, datasource.application, datasource.filter).subscribe(data => {
        if (data.errCode != -1 && data && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
          this._currentData.resouceDef.config.templateInterceptor['TemplateData'] = data.resource;
          this.loader.hideSpinner();
          this.openTemplIntersep(result, { templateInterceptor: this._currentData.resouceDef.config.templateInterceptor }, config, (res) => {
            if (res) {
              event.result['extra_data'] = res?.extra_data ?? null;
              this.saveData(event, null, true);
            }
          });
        }
        else {
          this.loader.hideSpinner();
          this.saveData(event, null, true);
        }
      })
    } catch (error) {
      this.saveData(event, null, true);
    }
  }


  openTemplIntersep(data: any, actionType, config?, callback?) {
    let popobj = { data: { action: actionType, data: data }, title: 'Template', size: DialogModalSize.Lg };
    if (config)
      popobj.data['config'] = config
    this.dialogService.open(TemplateInterceptorComponent, popobj).afterClosed.subscribe(res => {
      if (res) {
        callback(res);
      } else {
        callback(false)
      }
    });
  }
      
  manupulateArgs(data, args):any {
        let tempArgs = JSON.parse(JSON.stringify('!!!' + args + '!!!'));
        let finalargs = [];
        for (let val of data) {
            let strngVal = this.baseService.buildDyanamicStr(tempArgs, { 'data': val });
            finalargs.push(strngVal);
        }
        return args + ":" + finalargs.join('=');
  }


  openConfirmBox(data, action) {
    this.loader.hideSpinner();
    let popupTitle = "";
    this.translateService.translate(action.label ? action.label : action.title).subscribe(x => {
      if (x) {
        popupTitle = x;
      }
    });
    let name: string = "";
    if (action.name != undefined) {
      name = data[action.name];
    } else {
      name = "";
    }
    action['closeAfterSuccess'] = action.closeAfterSuccess != undefined ? action.closeAfterSuccess : false
    action['showCancel'] = action.showCancel != undefined ? action.showCancel : true
    var dialogRef;
    if (action.capability_datasource != undefined) {
      dialogRef = this.baseService.modalService.confirmCustomBtn(popupTitle, action.message, '', { cancel: "NO", ok: "YES" }, false);
    } else {
      dialogRef = this.modalService.confirm(popupTitle, action.message + ' ' + name + '?', ModalSize.Sm, action.showCancel, action.closeAfterSuccess);
    }
    dialogRef.subscribe(result => {
      if (result) {
        this.loader.showSpinner();
        if (action.datasource.data != undefined) {
          var res = action.datasource.data[0];
          for (let i = 0; i < Object.keys(res).length; i++) {
            data[Object.keys(res)[i]] = res[Object.keys(res)[i]];
          }
          this.confirmResource(data, action);
        } else if (action.datasource.url != undefined) {
          var url = this.baseService.buildDyanamicStr(action.datasource.url, { data: data });
          let i = document.createElement('iframe');
          i.src = url
          i.width = "1";
          i.height = "1";
          var r = document.querySelector('body').appendChild(i);
          setTimeout(() => {
            r.hidden = true
          }, 100)

          this.loader.hideSpinner();
        } else {
          this.confirmResource(data, action);
        }
      }
    },
      () => { });
  }

  confirmResource(item, action) {
    this.baseService.action(item, action.datasource.action, action.datasource.application, action.datasource.resource).subscribe(
      (data: any) => {
        console.log("confirm data:", data);
        this.communicationService.emitChange({ completed: true });
        if (data.errCode == -1) {
          this.alerts.error(data.message);
          if (action.refresh != undefined && action.refresh)
            this.bindGridFn();
        } else {
          if (action.closeAfterSuccess) {
            let modalId = this.bsModalService && this.bsModalService.config && this.bsModalService.config.id != undefined ? this.bsModalService.config.id : 1;
            this.bsModalService.hide(modalId);
            this.bsModalRef.hide();
          }
          if (this._currentData.currentAction == 'ADD') {
            this.alerts.success("Added Successfully");
          } else {
            this.alerts.success("Updated Successfully");
          }
          if (action.hasOwnProperty('redirectLink')) {
            let url = ''
            if (this.router.url.includes('?')) {
              this.postUrl(this.router.url.split('?')[0], action, item);
            } else {
              this.postUrl(this.router.url, action, item);
            }
          }
          if (action.show_message) {
            this.alerts.successWithMessage("", this.baseService.buildDyanamicStr(action.show_message, { data: data.resource[0] }))
          }
          this.bindGridFn();
        }
        this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        this.loader.hideSpinner();
      });
  }

  postUrl(url, action, data) {
    if (url == action.redirectLink) {
      url = this.router.url;
      this.router.navigate(["/search"]).then(() => {
        this.router.navigateByUrl(url);
      });
    } else if (action.queryParams) {
      this.customRoute(action, data)
    } else {
      url = action.redirectLink;
      this.router.navigateByUrl(url);
    }
  }

  getFilterValues(filterVal) {
    if (this._currentData.bannerJson && this._currentData.bannerJson.key && this._currentData.bannerJson.key != undefined) {
      filterVal = this.baseService.buildDyanamicStr(filterVal, { data: this._currentData.bannerJson.key });
    } else if (this._currentData.resouceDef && this._currentData.resouceDef.config && this._currentData.resouceDef.config.checkUrlFilter && this.activatedRoute.snapshot != undefined && this.activatedRoute.snapshot && this.activatedRoute.snapshot.queryParams != undefined) {
      filterVal = this.baseService.buildDyanamicStr(filterVal, { 'data': this.activatedRoute.snapshot.queryParams });
    } else {
      let data = {};
      try {
        data = JSON.parse(sessionStorage.getItem('currentData'));
        filterVal = this.baseService.buildDyanamicStr(filterVal, { data: data });
      } catch (error) {
        filterVal = this.baseService.buildDyanamicStr(filterVal, {});
      }

    }
    return filterVal
  }

  scrolltab(id, pos) {
    let elem = document.getElementById(id);
    if (elem) {
      this._currentData['tabScroll'] = this._currentData['tabScroll'] != undefined ? this._currentData['tabScroll'] : 0;
      elem.scrollLeft = pos == 'left' ? this._currentData['tabScroll'] + 100 : this._currentData['tabScroll'] - 100;
      this._currentData['tabScroll'] = elem.scrollLeft;
    }
  }

  checkSidebarOpen() {
    this.hasSubscription.add(this.asideBarService.asideBarClose().subscribe(res => {
      if (!this.utilService.isMobile())
        this.sidebarOpen = res;
    }))
  }
  threeDotClick(event) {
    if (this._currentData != undefined && this._currentData.decorator != undefined && this._currentData.decorator && this._currentData.decorator.processResourceDef != undefined) {
      this._currentData.decorator.bannerEvents(event);
    }
  }


  mapTagsWithGrid(data, ...restparameters) {
    let id = [];
    for (let val of data.resource) {
      id.push(val.id);
    }
    //creating argumnents for tag table
    let args = "application_resource:" + restparameters[0] + ",application_id:" + restparameters[1] + ",objectId:" + id.join('_');
    //gettting data from tag table
    this.baseService.get("GET_TAG_DATA", args, "tag_master_mapping", "rule-engine", "").subscribe(data_ => {
      if (data_.errCode == -1) {
        this.alerts.error(data_.message);

      }
      else {
        data.resource = data.resource.map((obj, index) => ({
          ...obj,
          ...data_.resource.find(x => x.objectId == obj.id)
        }))
        this._currentData.dataList = data;
      }
    })
  }

  //this method check to send order by in case of print only
  printOrderBy(gridData): boolean {
    if (gridData.printInfo != undefined && gridData.printInfo.actionType != undefined && gridData.printInfo.actionType != 'downloadCSV') {
      return false;//as we dont need to send order by in case of csv 
    }
    else {
      return true;
    }

  }

  toggleTabView(event) {
    //console.log('clicked');
    event.currentTarget.parentElement.parentElement.classList.toggle('expand');
  }

  // @HostListener('window:popstate', ['$event'])
  // onPopState(event) {
  //   console.log("Back Buton Pressed");
  //   localStorage.removeItem('setValueInForm');
  // }

  gridPopupConfigCheck() {
    let datasource = this._currentData.resouceDef.config.gridPopupConfig
    this.baseService.get(datasource.query_id, datasource.args, datasource.resource, datasource.application, datasource.filter).subscribe(
      result => {
        if (result.errCode == 0) {
          if (result.resource[0].config_value == "yes") {
            if (this._currentData.resouceDef?.config?.gridPopupPermission && this.rolePermissionService.checkAccessPermission(this._currentData.resouceDef.config.gridPopupPermission, this._currentData.resource)) {
              this._currentData.dataGridConfig.gridPopupValidation = true
            } else if (this._currentData.resouceDef?.config?.gridPopupPermission && !this.rolePermissionService.checkAccessPermission(this._currentData.resouceDef.config.gridPopupPermission, this._currentData.resource)) {
              this._currentData.dataGridConfig.gridPopupValidation = false
            } else {
              this._currentData.dataGridConfig.gridPopupValidation = true
            }
          } else {
            this._currentData.dataGridConfig.gridPopupValidation = false
          }
        }
      }
    )
  }

  gridPopupApi() {
    let datasource = this._currentData.resouceDef.config.gridPopupApi
    this.baseService.get(datasource.query_id, datasource.args, datasource.resource, datasource.application, datasource.filter).subscribe(data => {
      if (data) {
        let popObj = {
          resource: datasource.jsonResource,
          action: "LIST",
          title:  datasource.title,
          preDefinedData: { resource: data.resource },
          size: DialogModalSize.Lg,
          config: {
            "viewAll": false,
            "hideSearchBox": true,
            "allowPagination": true,
            "customButtonsAllowed": false,
            "noCount": 'hidden'
          }
        }
        this.dialogService.open(PopupFormComponent, popObj).afterClosed.subscribe(
          response => {
            if (response) { }
          });
      }
    })
  }

  async searchMenu(event: any) {
    const searchVal = event.target.value.trim().toLowerCase();
    const layoutStr = localStorage.getItem("emr_layoutData");
    const layout = layoutStr ? JSON.parse(layoutStr) : null;
    const current_data = layout ?? this._copy_layout_data;
    this._layout_data = await this.baseService.searchAndFilterMenu(searchVal, current_data);
  }

  /**
   * Collect composite-array fields with pagination_enabled from form blocks
   * @param blocks - Form blocks to traverse
   * @returns Promise<Set<string>> - Set of field names with pagination enabled
   */
  private async collectPaginatedFieldsFromForm(blocks: any[]): Promise<Set<string>> {
    const paginatedFields = new Set<string>();
    
    if (!blocks || !Array.isArray(blocks)) {
      return paginatedFields;
    }

    for (const block of blocks) {
      if (block.fields && Array.isArray(block.fields)) {
        for (const field of block.fields) {
          // Inherit from form.service.ts logic
          if (field.type == 'COMPOSITE-ARRAY') {
            if (field.component == 'composite-array') { } else {
              field.resource = field.component;
              field.component = 'composite-array';
            }
          }
          // Check if this is a composite-array with pagination_enabled
          if ((field.component === 'composite-array' || field.type === 'COMPOSITE-ARRAY') 
              && field.pagination_enabled) {
            paginatedFields.add(field.name);
          }

          // Recursively check nested composite-arrays by fetching their resource definition
          if (field.component === 'composite-array' || field.type === 'COMPOSITE-ARRAY') {
            if (field.resource) {
              await new Promise<void>((resolve) => {
                this.baseService.getResourceDef(field.resource, async (resourceDef) => {
                  if (resourceDef && resourceDef.form && resourceDef.form.blocks) {
                    const nestedFields = await this.collectPaginatedFieldsFromForm(resourceDef.form.blocks);
                    // Add nested fields with parent path
                    nestedFields.forEach(nestedField => {
                      paginatedFields.add(`${field.name}.${nestedField}`);
                    });
                  }
                  resolve();
                });
              });
            }
          }
        }
      }
    }

    return paginatedFields;
  }

}
